import type { SVGProps } from 'react';

export type IconRenderProps = { size?: number | string } & SVGProps<SVGSVGElement>;

const Icon_add = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.0005 3.98682C12.4146 3.98682 12.7503 4.32273 12.7505 4.73682V11.2505H19.2632C19.6774 11.2505 20.0132 11.5863 20.0132 12.0005C20.0132 12.4147 19.6774 12.7505 19.2632 12.7505H12.7505V19.2632C12.7505 19.6774 12.4147 20.0132 12.0005 20.0132C11.5863 20.0132 11.2505 19.6774 11.2505 19.2632V12.7505H4.73682C4.32273 12.7503 3.98682 12.4146 3.98682 12.0005C3.98682 11.5864 4.32273 11.2506 4.73682 11.2505H11.2505V4.73682C11.2506 4.32273 11.5864 3.98682 12.0005 3.98682Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_alert = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4755 3.338C13.642 2.65802 15.107 3.49955 15.1073 4.84972V19.1495C15.1071 20.4613 13.7164 21.3068 12.5516 20.7032L5.90027 17.2569H4.77332C3.25468 17.2568 2.02338 16.0256 2.02332 14.5069V9.93273C2.02332 8.41402 3.25464 7.18286 4.77332 7.18273H5.87878L12.4755 3.338ZM13.6073 4.84972C13.607 4.65712 13.3978 4.53707 13.2313 4.6339L6.83289 8.36241V16.0499L13.2421 19.3712C13.4084 19.4573 13.6071 19.3368 13.6073 19.1495V4.84972ZM4.77332 8.68273C4.08307 8.68286 3.52332 9.24245 3.52332 9.93273V14.5069C3.52338 15.1972 4.08311 15.7568 4.77332 15.7569H5.33289V8.68273H4.77332Z"
        fill="currentColor"
      />
      <path
        d="M18.7274 7.16124C19.0245 6.87261 19.5065 6.87261 19.8036 7.16124C22.7006 9.97598 22.7006 14.5398 19.8036 17.3546C19.5065 17.643 19.0245 17.643 18.7274 17.3546C18.4304 17.066 18.4305 16.5983 18.7274 16.3097C21.0306 14.0721 21.0306 10.4437 18.7274 8.20616C18.4304 7.91753 18.4303 7.44986 18.7274 7.16124Z"
        fill="currentColor"
      />
      <path
        d="M16.5214 9.3048C16.8184 9.01632 17.2995 9.01632 17.5966 9.3048C19.2754 10.9358 19.2754 13.5801 17.5966 15.211C17.2995 15.4994 16.8184 15.4994 16.5214 15.211C16.2243 14.9225 16.2244 14.4548 16.5214 14.1661C17.6058 13.1124 17.6058 11.4034 16.5214 10.3497C16.2243 10.0611 16.2243 9.59343 16.5214 9.3048Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_alignKorean = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.74994 11.5C8.16415 11.5 8.49994 11.8358 8.49994 12.25V13.5H10.7499C11.1642 13.5 11.4999 13.8358 11.4999 14.25C11.4999 14.6642 11.1642 15 10.7499 15H8.49994C9.88065 15 10.9999 16.1193 10.9999 17.5C10.9999 18.8807 9.88065 20 8.49994 20H6.74994C5.36923 20 4.24994 18.8807 4.24994 17.5C4.24994 16.1193 5.36923 15 6.74994 15H4.24994C3.83573 15 3.49994 14.6642 3.49994 14.25C3.49994 13.8358 3.83573 13.5 4.24994 13.5H6.99994V12.25C6.99994 11.8358 7.33573 11.5 7.74994 11.5ZM6.74994 16.5C6.19765 16.5 5.74994 16.9477 5.74994 17.5C5.74994 18.0523 6.19765 18.5 6.74994 18.5H8.49994C9.05222 18.5 9.49994 18.0523 9.49994 17.5C9.49994 16.9477 9.05222 16.5 8.49994 16.5H6.74994Z"
        fill="currentColor"
      />
      <path
        d="M17.2499 4C17.6642 4 17.9999 4.33579 17.9999 4.75V17.3047L19.1943 15.9873C19.4724 15.6803 19.9469 15.6565 20.2538 15.9346C20.5608 16.2127 20.5837 16.6872 20.3056 16.9941L17.8056 19.7539C17.6634 19.9107 17.4616 20 17.2499 20C17.0383 20 16.8364 19.9107 16.6943 19.7539L14.1943 16.9941C13.9162 16.6872 13.9391 16.2127 14.246 15.9346C14.553 15.6565 15.0275 15.6803 15.3056 15.9873L16.4999 17.3047V4.75C16.4999 4.33579 16.8357 4 17.2499 4Z"
        fill="currentColor"
      />
      <path
        d="M9.24994 4C10.2164 4 10.9999 4.7835 10.9999 5.75V10.25C10.9999 10.6642 10.6642 11 10.2499 11C9.83573 11 9.49994 10.6642 9.49994 10.25V5.75C9.49994 5.61193 9.38801 5.5 9.24994 5.5H4.24994C3.83573 5.5 3.49994 5.16421 3.49994 4.75C3.49994 4.33579 3.83573 4 4.24994 4H9.24994Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_archive = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.7998 2.0498C5.21396 2.0498 5.54971 2.38568 5.5498 2.7998V6.64258H10.4502V5.91797C10.4502 5.48024 10.6226 5.05999 10.9297 4.74805C11.2431 4.42976 11.6715 4.25 12.1182 4.25H14.7422C15.4983 4.25008 16.1694 4.73573 16.4053 5.4541L16.4873 5.70312C16.5211 5.8056 16.6167 5.875 16.7246 5.875H18.2002C19.1666 5.8751 19.9502 6.65856 19.9502 7.625V10.5C19.9502 11.4664 19.1666 12.2499 18.2002 12.25H12.2002C11.2337 12.25 10.4502 11.4665 10.4502 10.5V8.14258H5.5498V17.2998C5.5498 17.4378 5.66182 17.5497 5.7998 17.5498H10.4502V15.6182C10.4502 15.1804 10.6226 14.7602 10.9297 14.4482C11.2431 14.1299 11.6714 13.9502 12.1182 13.9502H14.7422C15.4983 13.9503 16.1694 14.4359 16.4053 15.1543L16.4873 15.4033C16.5211 15.5057 16.6167 15.5752 16.7246 15.5752H18.2002C19.1666 15.5753 19.9502 16.3588 19.9502 17.3252V20.2002C19.9501 21.1665 19.1665 21.9501 18.2002 21.9502H12.2002C11.2338 21.9502 10.4503 21.1666 10.4502 20.2002V19.0498H5.7998C4.83339 19.0497 4.0498 18.2662 4.0498 17.2998V2.7998C4.0499 2.38574 4.38574 2.0499 4.7998 2.0498ZM12.1182 15.4502C12.0733 15.4502 12.0295 15.468 11.998 15.5C11.9672 15.5313 11.9502 15.5742 11.9502 15.6182V20.2002C11.9503 20.3382 12.0622 20.4502 12.2002 20.4502H18.2002C18.3381 20.4501 18.4501 20.3381 18.4502 20.2002V17.3252C18.4502 17.1872 18.3382 17.0753 18.2002 17.0752H16.7246C15.9685 17.0752 15.2974 16.5894 15.0615 15.8711L14.9805 15.6221C14.9468 15.5195 14.8501 15.4503 14.7422 15.4502H12.1182ZM12.1182 5.75C12.0733 5.75 12.0295 5.76787 11.998 5.7998C11.9672 5.83115 11.9502 5.874 11.9502 5.91797V10.5C11.9502 10.6381 12.0621 10.75 12.2002 10.75H18.2002C18.3382 10.7499 18.4502 10.638 18.4502 10.5V7.625C18.4502 7.48699 18.3382 7.3751 18.2002 7.375H16.7246C15.9684 7.375 15.2974 6.88934 15.0615 6.1709L14.9805 5.92188C14.9468 5.81931 14.8501 5.75008 14.7422 5.75H12.1182Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_arrowDown = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.2502 2.77502C11.2502 2.36081 11.586 2.02502 12.0002 2.02502C12.4143 2.02513 12.7502 2.36088 12.7502 2.77502V19.4147L18.6701 13.4948C18.963 13.2021 19.4378 13.2019 19.7307 13.4948C20.0233 13.7876 20.0233 14.2625 19.7307 14.5553L12.5305 21.7555C12.3899 21.8961 12.199 21.9752 12.0002 21.9752C11.8014 21.9752 11.6105 21.896 11.4699 21.7555L4.26972 14.5553C3.97683 14.2624 3.97683 13.7876 4.26972 13.4948C4.56261 13.2019 5.03737 13.2019 5.33027 13.4948L11.2502 19.4147V2.77502Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_arrowLeft = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.44492 4.26967C9.73782 3.97687 10.2126 3.97681 10.5055 4.26967C10.7982 4.56254 10.7982 5.03735 10.5055 5.33022L4.58554 11.2501H21.2252C21.6393 11.2502 21.9752 11.586 21.9752 12.0001C21.9751 12.4142 21.6392 12.75 21.2252 12.7501H4.58554L10.5055 18.6701C10.7981 18.963 10.7983 19.4378 10.5055 19.7306C10.2127 20.0233 9.7378 20.0232 9.44492 19.7306L2.24472 12.5304C2.10411 12.3898 2.02505 12.199 2.02499 12.0001C2.02499 11.8013 2.10413 11.6105 2.24472 11.4699L9.44492 4.26967Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_arrowRight = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13.4947 4.26972C13.7876 3.97683 14.2624 3.97683 14.5553 4.26972L21.7555 11.4699C21.896 11.6105 21.9752 11.8014 21.9752 12.0002C21.9751 12.199 21.8961 12.3899 21.7555 12.5305L14.5553 19.7307C14.2624 20.0233 13.7876 20.0233 13.4947 19.7307C13.2019 19.4378 13.202 18.963 13.4947 18.6701L19.4146 12.7502H2.77499C2.36085 12.7502 2.0251 12.4143 2.02499 12.0002C2.02499 11.586 2.36078 11.2502 2.77499 11.2502H19.4146L13.4947 5.33027C13.2018 5.03737 13.2018 4.56261 13.4947 4.26972Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_arrowUp = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.2502 21.2252V4.58557L5.33025 10.5055C5.03738 10.7983 4.56257 10.7983 4.2697 10.5055C3.97684 10.2126 3.9769 9.73785 4.2697 9.44495L11.4699 2.24475L11.5842 2.151C11.7064 2.06953 11.8511 2.02502 12.0002 2.02502C12.199 2.02508 12.3898 2.10414 12.5304 2.24475L19.7306 9.44495C20.0232 9.73783 20.0233 10.2127 19.7306 10.5055C19.4378 10.7983 18.963 10.7981 18.6701 10.5055L12.7502 4.58557V21.2252C12.7501 21.6393 12.4142 21.9751 12.0002 21.9752C11.586 21.9752 11.2503 21.6393 11.2502 21.2252Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_asterisk = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.1736 2.91895C12.3072 2.91895 12.4174 3.02382 12.4236 3.15723L12.7644 10.6738L19.4461 7.21191C19.5647 7.15042 19.7112 7.19288 19.7781 7.30859L19.9519 7.61035C20.0184 7.72598 19.9822 7.87332 19.8699 7.94531L13.53 11.999L19.8699 16.0547C19.9822 16.1267 20.0184 16.274 19.9519 16.3896L19.7781 16.6914C19.7113 16.8071 19.5647 16.8496 19.4461 16.7881L12.7654 13.3252L12.4236 20.8428C12.4174 20.9762 12.3072 21.0811 12.1736 21.0811H11.8259C11.6925 21.0809 11.5831 20.9761 11.5769 20.8428L11.2341 13.3252L4.55445 16.7881C4.43582 16.8496 4.28927 16.8071 4.22242 16.6914L4.04859 16.3896C3.98202 16.2739 4.01814 16.1266 4.13063 16.0547L10.4695 12L4.13063 7.94531C4.01813 7.87336 3.98201 7.72606 4.04859 7.61035L4.22242 7.30859C4.28928 7.19292 4.43582 7.15043 4.55445 7.21191L11.2341 10.6738L11.5769 3.15723C11.5831 3.02392 11.6925 2.91909 11.8259 2.91895H12.1736Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_attachFile = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.6523 3.07379C14.3559 1.37019 17.1185 1.37033 18.8222 3.07379C20.5259 4.77745 20.5259 7.54005 18.8222 9.24371L11.2519 16.814C10.1291 17.9368 8.30824 17.9368 7.18548 16.814C6.06307 15.6913 6.06305 13.8713 7.18548 12.7486L14.2509 5.68316C14.5438 5.39039 15.0186 5.39041 15.3115 5.68316C15.6043 5.97602 15.6043 6.45081 15.3115 6.74371L8.24603 13.8091C7.70938 14.346 7.7094 15.2166 8.24603 15.7535C8.783 16.2904 9.65437 16.2904 10.1913 15.7535L17.7617 8.18316C18.8794 7.06538 18.8792 5.25321 17.7617 4.13531C16.6438 3.01743 14.8317 3.01743 13.7138 4.13531L5.11614 12.732C3.45641 14.3917 3.45641 17.083 5.11614 18.7427L5.25677 18.8843C6.91645 20.544 9.60777 20.5439 11.2675 18.8843L18.748 11.4039C19.0409 11.1112 19.5157 11.1111 19.8085 11.4039C20.1013 11.6967 20.1012 12.1715 19.8085 12.4644L12.3281 19.9449C10.0825 22.1903 6.44169 22.1904 4.19622 19.9449L4.0556 19.8033C1.81008 17.5578 1.81008 13.917 4.0556 11.6714L12.6523 3.07379Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_barcode = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.25 3C5.66421 3 6 3.33579 6 3.75V20.25C6 20.6642 5.66421 21 5.25 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75C3 3.33579 3.33579 3 3.75 3H5.25Z"
        fill="currentColor"
      />
      <path
        d="M7.5 3C7.91421 3 8.25 3.33579 8.25 3.75V20.25C8.25 20.6642 7.91421 21 7.5 21C7.08579 21 6.75 20.6642 6.75 20.25V3.75C6.75 3.33579 7.08579 3 7.5 3Z"
        fill="currentColor"
      />
      <path
        d="M9.75 3C10.1642 3 10.5 3.33579 10.5 3.75V20.25C10.5 20.6642 10.1642 21 9.75 21C9.33579 21 9 20.6642 9 20.25V3.75C9 3.33579 9.33579 3 9.75 3Z"
        fill="currentColor"
      />
      <path
        d="M13.5 3C13.9142 3 14.25 3.33579 14.25 3.75V20.25C14.25 20.6642 13.9142 21 13.5 21H12C11.5858 21 11.25 20.6642 11.25 20.25V3.75C11.25 3.33579 11.5858 3 12 3H13.5Z"
        fill="currentColor"
      />
      <path
        d="M15.75 3C16.1642 3 16.5 3.33579 16.5 3.75V20.25C16.5 20.6642 16.1642 21 15.75 21C15.3358 21 15 20.6642 15 20.25V3.75C15 3.33579 15.3358 3 15.75 3Z"
        fill="currentColor"
      />
      <path
        d="M20.25 3C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H18.75C18.3358 21 18 20.6642 18 20.25V3.75C18 3.33579 18.3358 3 18.75 3H20.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_bell = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9997 2C12.8281 2 13.4997 2.67157 13.4997 3.5V4.16504C16.4633 4.82344 18.6734 7.38936 18.6735 10.4561V14.1465L18.6843 14.3301C18.7846 15.2926 19.607 16.8595 20.2468 17.4785C20.9292 18.1386 20.1161 19 19.1511 19H14.9938C14.9938 19.0028 14.994 19.0059 14.9938 19.0088C14.8967 20.6781 13.5933 22 11.9997 22C10.4062 21.9998 9.10269 20.678 9.00556 19.0088C9.00539 19.0059 9.00559 19.0028 9.00556 19H4.84833L4.66962 18.9902C3.78764 18.8932 3.11313 18.0974 3.75263 17.4785C4.39237 16.8596 5.21478 15.2927 5.31513 14.3301L5.32587 14.1465V10.4561C5.32596 7.38957 7.53635 4.82365 10.4997 4.16504V3.5C10.4997 2.67167 11.1714 2.00016 11.9997 2ZM11.9997 5.5C9.0949 5.50016 6.82597 7.76554 6.82587 10.4561V14.1465C6.82577 14.9672 6.47479 15.89 6.14423 16.5703C5.99522 16.8769 5.81805 17.1956 5.6247 17.5H18.3747C18.1813 17.1956 18.0042 16.8769 17.8552 16.5703C17.5246 15.89 17.1736 14.9671 17.1735 14.1465V10.4561C17.1734 7.76545 14.9046 5.5 11.9997 5.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_bill = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2891 8.7998C16.4208 8.40733 16.8457 8.19563 17.2383 8.32715C17.6309 8.45871 17.8423 8.88369 17.7109 9.27637L16.8818 11.75H18C18.4142 11.75 18.75 12.0858 18.75 12.5C18.75 12.9142 18.4142 13.25 18 13.25H16.3799L15.6035 15.5664C15.2492 16.6239 13.7487 16.6085 13.416 15.5439L12.6992 13.25H11.3008L10.584 15.5439C10.2513 16.6085 8.7508 16.6239 8.39648 15.5664L7.62012 13.25H6C5.58579 13.25 5.25 12.9142 5.25 12.5C5.25 12.0858 5.58579 11.75 6 11.75H7.11816L6.28906 9.27637C6.15765 8.88369 6.36905 8.45871 6.76172 8.32715C7.15433 8.19563 7.57919 8.40733 7.71094 8.7998L8.69922 11.75H10.1982L10.9023 9.49805L10.9375 9.40039C11.3201 8.45471 12.6799 8.45472 13.0625 9.40039L13.0977 9.49805L13.8018 11.75H15.3008L16.2891 8.7998ZM9.47461 14.0645L9.72949 13.25H9.20215L9.47461 14.0645ZM14.5244 14.0645L14.7979 13.25H14.2705L14.5244 14.0645ZM11.7695 11.75H12.2305L12 11.0137L11.7695 11.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 4.25C20.7426 4.25 21.75 5.25736 21.75 6.5V17.5C21.75 18.7426 20.7426 19.75 19.5 19.75H4.5C3.25736 19.75 2.25 18.7426 2.25 17.5L2.25 6.5C2.25 5.25736 3.25736 4.25 4.5 4.25H19.5ZM4.5 5.75C4.08579 5.75 3.75 6.08579 3.75 6.5V17.5C3.75 17.9142 4.08579 18.25 4.5 18.25H19.5C19.9142 18.25 20.25 17.9142 20.25 17.5V6.5C20.25 6.08579 19.9142 5.75 19.5 5.75H4.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_board = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15 14.25C15.4142 14.25 15.75 14.5858 15.75 15C15.75 15.4142 15.4142 15.75 15 15.75H9C8.58579 15.75 8.25 15.4142 8.25 15C8.25 14.5858 8.58579 14.25 9 14.25H15Z"
        fill="currentColor"
      />
      <path
        d="M15 10.25C15.4142 10.25 15.75 10.5858 15.75 11C15.75 11.4142 15.4142 11.75 15 11.75H9C8.58579 11.75 8.25 11.4142 8.25 11C8.25 10.5858 8.58579 10.25 9 10.25H15Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.75 2.0498C14.5699 2.0498 15.2733 2.54394 15.582 3.25H18.2002C19.1665 3.25021 19.9502 4.03363 19.9502 5V20.2002C19.9501 21.1665 19.1664 21.95 18.2002 21.9502H5.7998C4.83346 21.9501 4.04991 21.1665 4.0498 20.2002V5C4.0498 4.03356 4.83339 3.2501 5.7998 3.25H8.41797C8.72672 2.54394 9.43009 2.0498 10.25 2.0498H13.75ZM5.7998 4.75C5.66182 4.7501 5.5498 4.86199 5.5498 5V20.2002C5.54991 20.3381 5.66188 20.4501 5.7998 20.4502H18.2002C18.338 20.45 18.4501 20.338 18.4502 20.2002V5C18.4502 4.86206 18.3381 4.75021 18.2002 4.75H15.6211C15.3371 5.50881 14.6079 6.0498 13.75 6.0498H10.25C9.39207 6.0498 8.66292 5.50881 8.37891 4.75H5.7998ZM10.25 3.5498C9.97392 3.5498 9.7501 3.77375 9.75 4.0498C9.75 4.32595 9.97386 4.5498 10.25 4.5498H13.75C14.0261 4.5498 14.25 4.32595 14.25 4.0498C14.2499 3.77375 14.0261 3.5498 13.75 3.5498H10.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_box = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4014 2.21916C11.7875 2.07874 12.2115 2.07886 12.5977 2.21916L20.7979 5.20158C21.4894 5.45308 21.9502 6.11024 21.9502 6.84612V17.1547C21.95 17.8904 21.4893 18.5478 20.7979 18.7992L12.5977 21.7807C12.2114 21.9211 11.7876 21.9211 11.4014 21.7807L3.20215 18.7992C2.51079 18.5478 2.04997 17.8904 2.0498 17.1547V6.84612C2.0498 6.1103 2.51067 5.45312 3.20215 5.20158L11.4014 2.21916ZM3.5498 17.1547C3.54997 17.2596 3.61626 17.3532 3.71484 17.3891L11.25 20.1293V9.66545L8.15039 8.63225V11.4252C8.15018 11.8391 7.81429 12.175 7.40039 12.1752C6.98631 12.1752 6.6506 11.8393 6.65039 11.4252V8.13225L3.5498 7.09905V17.1547ZM12.75 9.66545V20.1293L20.2852 17.3891C20.3838 17.3532 20.45 17.2597 20.4502 17.1547V7.09905L12.75 9.66545ZM15.9854 5.04729C15.914 5.12066 15.8279 5.18189 15.7266 5.22209L9.75195 7.5844L12 8.3344L18.7949 6.06877L15.9854 5.04729ZM12.085 3.62932C12.0299 3.6094 11.9691 3.6093 11.9141 3.62932L5.2041 6.06877L7.54004 6.84709L13.9561 4.30901L12.085 3.62932Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_camera = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7.75C14.6234 7.75 16.75 9.87665 16.75 12.5C16.75 15.1234 14.6234 17.25 12 17.25C9.37665 17.25 7.25 15.1234 7.25 12.5C7.25 9.87665 9.37665 7.75 12 7.75ZM12 9.25C10.2051 9.25 8.75 10.7051 8.75 12.5C8.75 14.2949 10.2051 15.75 12 15.75C13.7949 15.75 15.25 14.2949 15.25 12.5C15.25 10.7051 13.7949 9.25 12 9.25Z"
        fill="currentColor"
      />
      <path
        d="M19.1426 8.17871C19.6685 8.17871 20.0947 8.60492 20.0947 9.13086C20.0947 9.65685 19.6686 10.083 19.1426 10.083C18.6167 10.0829 18.1904 9.65677 18.1904 9.13086C18.1905 8.605 18.6167 8.17884 19.1426 8.17871Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5352 2.66699C15.1603 2.66705 15.7382 3.00059 16.0508 3.54199L17.123 5.39941C17.1677 5.47635 17.2499 5.52428 17.3389 5.52441H20C21.5188 5.52441 22.75 6.75563 22.75 8.27441V18.084C22.7497 19.6025 21.5186 20.834 20 20.834H4C2.48141 20.834 1.25031 19.6025 1.25 18.084V8.27441C1.25 6.75563 2.48122 5.52441 4 5.52441H6.43945C6.52862 5.52441 6.61154 5.47653 6.65625 5.39941L7.72852 3.54199C8.04113 3.00055 8.61893 2.66699 9.24414 2.66699H14.5352ZM9.24414 4.16699C9.15482 4.16699 9.072 4.21464 9.02734 4.29199L7.95508 6.14941C7.64241 6.69058 7.06448 7.02441 6.43945 7.02441H4C3.30964 7.02441 2.75 7.58406 2.75 8.27441V18.084C2.75031 18.7741 3.30984 19.334 4 19.334H20C20.6902 19.334 21.2497 18.7741 21.25 18.084V8.27441C21.25 7.58406 20.6904 7.02441 20 7.02441H17.3389C16.7139 7.02428 16.1358 6.69064 15.8232 6.14941L14.752 4.29199C14.7073 4.21469 14.6244 4.16705 14.5352 4.16699H9.24414Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_cancelFill = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.9697 6.96973C16.2626 6.67683 16.7374 6.67683 17.0303 6.96973C17.3232 7.26262 17.3232 7.73738 17.0303 8.03027L13.0605 12L17.0303 15.9697C17.3229 16.2626 17.3231 16.7375 17.0303 17.0303C16.7375 17.3231 16.2626 17.3229 15.9697 17.0303L12 13.0605L8.03027 17.0303C7.73736 17.3229 7.26253 17.3231 6.96973 17.0303C6.67692 16.7375 6.6771 16.2626 6.96973 15.9697L10.9395 12L6.96973 8.03027C6.67683 7.73738 6.67683 7.26262 6.96973 6.96973C7.26262 6.67683 7.73738 6.67683 8.03027 6.96973L12 10.9395L15.9697 6.96973Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.0498C18.0474 1.04991 22.9501 5.95263 22.9502 12C22.9501 18.0474 18.0474 22.9501 12 22.9502C5.95266 22.9501 1.04991 18.0473 1.0498 12C1.0499 5.95265 5.95265 1.04994 12 1.0498ZM12 2.5498C6.78108 2.54994 2.5499 6.78107 2.5498 12C2.54991 17.2189 6.78109 21.4501 12 21.4502C17.2189 21.4501 21.4501 17.2189 21.4502 12C21.4501 6.78106 17.2189 2.54991 12 2.5498Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_cancelOutline = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM17.0303 6.96973C16.7374 6.67684 16.2626 6.67684 15.9697 6.96973L12 10.9395L8.03027 6.96973C7.73738 6.67684 7.26262 6.67684 6.96973 6.96973C6.67683 7.26262 6.67684 7.73738 6.96973 8.03027L10.9395 12L6.96973 15.9697C6.67711 16.2626 6.67693 16.7375 6.96973 17.0303C7.26253 17.323 7.73738 17.3229 8.03027 17.0303L12 13.0605L15.9697 17.0303C16.2626 17.3228 16.7375 17.3231 17.0303 17.0303C17.3231 16.7375 17.3228 16.2626 17.0303 15.9697L13.0605 12L17.0303 8.03027C17.3231 7.7374 17.3231 7.26262 17.0303 6.96973Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_caretDown = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M19.2188 8.25C19.9555 8.25 20.2813 9.44246 19.7061 10.0342L12.4874 17.46C12.2028 17.7526 11.7974 17.7526 11.5127 17.46L4.294 10.0342C3.71879 9.44247 4.04461 8.25 4.7813 8.25H19.2188Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_caretLeft = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.1423 4.29416C14.7698 3.71888 16.0358 4.04475 16.0358 4.78146V19.219C16.0358 19.9557 14.7698 20.2815 14.1423 19.7063L6.26827 12.4865C5.95813 12.2019 5.95791 11.7975 6.26827 11.5129L14.1423 4.29416Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_caretRight = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.25 4.78127C8.25 4.04456 9.44248 3.71871 10.0342 4.29397L17.46 11.5127C17.7526 11.7973 17.7526 12.2027 17.46 12.4873L10.0342 19.7061C9.44249 20.2814 8.25 19.9555 8.25 19.2188V4.78127Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_caretUp = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.6252 6.44362C11.8583 6.27919 12.1422 6.27906 12.3752 6.44362L12.4865 6.5403L19.7063 13.9651C20.2815 14.5568 19.9557 15.7503 19.219 15.7503H4.78146C4.04475 15.7503 3.71888 14.5568 4.29416 13.9651L11.5129 6.5403L11.6252 6.44362Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_check = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20.6621 5.86456C20.955 5.57167 21.4298 5.57168 21.7227 5.86456C22.0156 6.15746 22.0156 6.63222 21.7227 6.92511L10.5859 18.0618C10.1954 18.4523 9.56241 18.4523 9.17188 18.0618L2.27735 11.1683C1.98445 10.8754 1.98445 10.3996 2.27735 10.1068C2.57018 9.81416 3.04506 9.81416 3.3379 10.1068L9.87891 16.6478L20.6621 5.86456Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_checkFill = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM18.1299 8.46973C17.837 8.17703 17.3622 8.1769 17.0693 8.46973L10.8125 14.7275L7.09961 11.0146C6.80684 10.7221 6.33191 10.7223 6.03906 11.0146C5.74625 11.3075 5.7464 11.7823 6.03906 12.0752L10.1045 16.1416C10.495 16.5321 11.129 16.5321 11.5195 16.1416L18.1299 9.53027C18.4228 9.23738 18.4228 8.76262 18.1299 8.46973Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_checkOutline = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17.0693 8.46973C17.3622 8.1769 17.837 8.17703 18.1299 8.46973C18.4228 8.76262 18.4228 9.23738 18.1299 9.53027L11.5195 16.1416C11.129 16.5321 10.495 16.5321 10.1045 16.1416L6.03906 12.0752C5.7464 11.7823 5.74625 11.3075 6.03906 11.0146C6.33191 10.7223 6.80684 10.7221 7.09961 11.0146L10.8125 14.7275L17.0693 8.46973Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0.25C18.4893 0.25 23.75 5.51065 23.75 12C23.75 18.4893 18.4893 23.75 12 23.75C5.51065 23.75 0.25 18.4893 0.25 12C0.25 5.51065 5.51065 0.25 12 0.25ZM12 1.75C6.33908 1.75 1.75 6.33908 1.75 12C1.75 17.6609 6.33908 22.25 12 22.25C17.6609 22.25 22.25 17.6609 22.25 12C22.25 6.33908 17.6609 1.75 12 1.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_checkboxCheck = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.5962 3.19751L5.02773 8.76598C4.97891 8.81479 4.89977 8.81479 4.85095 8.76598L1.40381 5.31883"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

const Icon_checkboxIndeterminate = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M2 6H10" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
};

const Icon_chevronDown = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20.676 6.96383C20.9721 6.6744 21.447 6.67953 21.7365 6.97555C22.0259 7.2716 22.0207 7.7465 21.7248 8.03609L12.6994 16.8652C12.3108 17.2453 11.6897 17.2452 11.301 16.8652L2.27559 8.03609C1.97951 7.74645 1.97425 7.27164 2.26388 6.97555C2.55352 6.67946 3.02833 6.6742 3.32442 6.96383L12.0002 15.4502L20.676 6.96383Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_chevronLeft = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.964 2.2756C16.2536 1.97953 16.7285 1.97423 17.0245 2.26388C17.3206 2.55351 17.3258 3.02834 17.0363 3.32443L8.54895 12.0002L17.0363 20.676C17.3256 20.9721 17.3205 21.447 17.0245 21.7365C16.7285 22.026 16.2536 22.0206 15.964 21.7248L7.13489 12.6994C6.75471 12.3108 6.75481 11.6897 7.13489 11.301L15.964 2.2756Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_chevronLeftEnd = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.9141 2.27542C13.2037 1.97944 13.6786 1.97411 13.9746 2.2637C14.2706 2.55332 14.2759 3.02816 13.9864 3.32425L5.50003 12L13.9864 20.6758C14.2757 20.9719 14.2705 21.4468 13.9746 21.7364C13.6786 22.0257 13.2037 22.0205 12.9141 21.7246L4.08499 12.6993C3.70484 12.3106 3.70497 11.6895 4.08499 11.3008L12.9141 2.27542Z"
        fill="currentColor"
      />
      <path
        d="M18.9141 2.27542C19.2037 1.97944 19.6786 1.97411 19.9746 2.2637C20.2706 2.55332 20.2759 3.02816 19.9864 3.32425L11.5 12L19.9864 20.6758C20.2757 20.9719 20.2705 21.4468 19.9746 21.7364C19.6786 22.0257 19.2037 22.0205 18.9141 21.7246L10.085 12.6993C9.70484 12.3106 9.70497 11.6895 10.085 11.3008L18.9141 2.27542Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_chevronRight = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.97558 2.26388C7.27167 1.97425 7.74648 1.97951 8.03612 2.27559L16.8652 11.301C17.2452 11.6897 17.2454 12.3108 16.8652 12.6994L8.03612 21.7248C7.74653 22.0207 7.27163 22.0259 6.97558 21.7365C6.67956 21.447 6.67443 20.9721 6.96386 20.676L15.4502 12.0002L6.96386 3.32442C6.67423 3.02833 6.67949 2.55352 6.97558 2.26388Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_chevronRightEnd = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.02539 2.26357C4.32145 1.9742 4.79634 1.97944 5.08594 2.27529L13.915 11.3007C14.2949 11.6893 14.295 12.3105 13.915 12.6991L5.08594 21.7245C4.79636 22.0204 4.32145 22.0256 4.02539 21.7362C3.72936 21.4466 3.72421 20.9718 4.01367 20.6757L12.5 11.9999L4.01367 3.32412C3.7243 3.02806 3.72953 2.55317 4.02539 2.26357Z"
        fill="currentColor"
      />
      <path
        d="M10.0254 2.26357C10.3214 1.9742 10.7963 1.97944 11.0859 2.27529L19.915 11.3007C20.2949 11.6893 20.295 12.3105 19.915 12.6991L11.0859 21.7245C10.7964 22.0204 10.3215 22.0256 10.0254 21.7362C9.72936 21.4466 9.72421 20.9718 10.0137 20.6757L18.5 11.9999L10.0137 3.32412C9.7243 3.02806 9.72953 2.55317 10.0254 2.26357Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_chevronUp = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.3762 7.06845C11.7403 6.77705 12.2602 6.77692 12.6242 7.06845L12.6994 7.13486L21.7248 15.964C22.0206 16.2536 22.026 16.7285 21.7365 17.0245C21.447 17.3205 20.9721 17.3256 20.676 17.0362L12.0002 8.54892L3.32443 17.0362C3.02834 17.3258 2.55351 17.3205 2.26388 17.0245C1.97423 16.7284 1.97953 16.2536 2.2756 15.964L11.301 7.13486L11.3762 7.06845Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_clockFill = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 4.25C11.5858 4.25 11.25 4.58579 11.25 5V12C11.25 12.4142 11.5858 12.75 12 12.75H19C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H12.75V5C12.75 4.58579 12.4142 4.25 12 4.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_clockOutline = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 4.25C12.4141 4.2501 12.75 4.58585 12.75 5V11.25H19C19.4141 11.2501 19.75 11.5858 19.75 12C19.7499 12.4141 19.4141 12.7499 19 12.75H12C11.5858 12.75 11.2501 12.4141 11.25 12V5C11.25 4.58579 11.5858 4.25 12 4.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.0498C18.0474 1.04991 22.9502 5.95255 22.9502 12C22.9501 18.0474 18.0474 22.9501 12 22.9502C5.95255 22.9502 1.04991 18.0474 1.0498 12C1.0498 5.95248 5.95248 1.0498 12 1.0498ZM12 2.5498C6.78091 2.5498 2.5498 6.78091 2.5498 12C2.54991 17.219 6.78097 21.4502 12 21.4502C17.2189 21.4501 21.4501 17.2189 21.4502 12C21.4502 6.78097 17.219 2.54991 12 2.5498Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_close = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M18.8281 4.11135C19.121 3.81849 19.5958 3.81854 19.8887 4.11135C20.1816 4.40424 20.1816 4.879 19.8887 5.1719L13.0596 12L19.8887 18.8291C20.1815 19.122 20.1815 19.5968 19.8887 19.8897C19.5958 20.1822 19.1209 20.1824 18.8281 19.8897L12 13.0606L5.17188 19.8897C4.87911 20.1823 4.40422 20.1821 4.11133 19.8897C3.81844 19.5968 3.81844 19.121 4.11133 18.8281L10.9385 12L4.11133 5.1719C3.81844 4.879 3.81844 4.40424 4.11133 4.11135C4.40424 3.8186 4.87903 3.81851 5.17188 4.11135L11.999 10.9395L18.8281 4.11135Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_copy = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 7.54395C20.9664 7.54404 21.7499 8.32759 21.75 9.29395V20C21.7499 20.9664 20.9664 21.7499 20 21.75H9.29395C8.32756 21.7499 7.54404 20.9664 7.54395 20V9.29395C7.54404 8.32757 8.32757 7.54401 9.29395 7.54395H20ZM9.29395 9.04395C9.15599 9.04401 9.04404 9.156 9.04395 9.29395V20C9.04404 20.138 9.15599 20.2499 9.29395 20.25H20C20.1379 20.2499 20.2499 20.1379 20.25 20V9.29395C20.2499 9.15602 20.1379 9.04404 20 9.04395H9.29395Z"
        fill="currentColor"
      />
      <path
        d="M14.7061 2.25C15.6725 2.25009 16.4561 3.03356 16.4561 4V6C16.4561 6.41416 16.1202 6.74991 15.7061 6.75C15.2918 6.75 14.9561 6.41421 14.9561 6V4C14.9561 3.86199 14.844 3.75009 14.7061 3.75H4C3.86193 3.75 3.75 3.86193 3.75 4V14.7061C3.75009 14.844 3.86199 14.9561 4 14.9561H6C6.41421 14.9561 6.75 15.2918 6.75 15.7061C6.74991 16.1202 6.41416 16.4561 6 16.4561H4C3.03356 16.4561 2.25009 15.6725 2.25 14.7061V4C2.25 3.0335 3.0335 2.25 4 2.25H14.7061Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_coupon = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15 13.5C15.8284 13.5 16.5 14.1716 16.5 15C16.5 15.8284 15.8284 16.5 15 16.5C14.1716 16.5 13.5 15.8284 13.5 15C13.5 14.1716 14.1716 13.5 15 13.5Z"
        fill="currentColor"
      />
      <path
        d="M14.9092 7.96973C15.2021 7.67705 15.6769 7.67691 15.9697 7.96973C16.2625 8.26255 16.2624 8.73738 15.9697 9.03027L9.03027 15.9697C8.73739 16.2625 8.26261 16.2625 7.96973 15.9697C7.67685 15.6769 7.67689 15.2021 7.96973 14.9092L14.9092 7.96973Z"
        fill="currentColor"
      />
      <path
        d="M9 7.5C9.82843 7.5 10.5 8.17157 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 4.25C20.7426 4.25 21.75 5.25736 21.75 6.5V9C21.75 9.5042 21.5307 9.91547 21.2715 10.2178C21.0155 10.5162 20.6946 10.7418 20.4014 10.9023C20.0117 11.1156 19.75 11.5278 19.75 12C19.75 12.4722 20.0117 12.8844 20.4014 13.0977C20.6946 13.2582 21.0155 13.4838 21.2715 13.7822C21.5307 14.0845 21.75 14.4958 21.75 15V17.5C21.75 18.7426 20.7426 19.75 19.5 19.75H4.5C3.25736 19.75 2.25 18.7426 2.25 17.5V15C2.25 14.4958 2.46932 14.0845 2.72852 13.7822C2.98448 13.4838 3.30543 13.2582 3.59863 13.0977C3.98828 12.8844 4.25 12.4722 4.25 12C4.25 11.5278 3.98828 11.1156 3.59863 10.9023C3.30543 10.7418 2.98448 10.5162 2.72852 10.2178C2.46932 9.91547 2.25 9.5042 2.25 9L2.25 6.5C2.25 5.25736 3.25736 4.25 4.5 4.25H19.5ZM4.5 5.75C4.08579 5.75 3.75 6.08579 3.75 6.5V9C3.75 9.04794 3.76826 9.12579 3.86719 9.24121C3.96955 9.36057 4.12814 9.48225 4.31934 9.58691C5.17022 10.0528 5.75 10.9581 5.75 12C5.75 13.0419 5.17022 13.9472 4.31934 14.4131C4.12814 14.5178 3.96955 14.6394 3.86719 14.7588C3.76826 14.8742 3.75 14.9521 3.75 15V17.5C3.75 17.9142 4.08579 18.25 4.5 18.25H19.5C19.9142 18.25 20.25 17.9142 20.25 17.5V15C20.25 14.9521 20.2317 14.8742 20.1328 14.7588C20.0304 14.6394 19.8719 14.5178 19.6807 14.4131C18.8298 13.9472 18.25 13.0419 18.25 12C18.25 10.9581 18.8298 10.0528 19.6807 9.58691C19.8719 9.48225 20.0304 9.36057 20.1328 9.24121C20.2317 9.12579 20.25 9.04794 20.25 9V6.5C20.25 6.08579 19.9142 5.75 19.5 5.75H4.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_dashboard = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11 13.25C11 13.5261 10.7761 13.75 10.5 13.75L6.5 13.75C6.22386 13.75 6 13.5261 6 13.25L6 7.25C6 6.97386 6.22386 6.75 6.5 6.75L10.5 6.75C10.7761 6.75 11 6.97386 11 7.25L11 13.25Z"
        fill="currentColor"
      />
      <path
        d="M18 9.25C18 9.52614 17.7761 9.75 17.5 9.75L13.5 9.75C13.2239 9.75 13 9.52614 13 9.25L13 7.25C13 6.97386 13.2239 6.75 13.5 6.75L17.5 6.75C17.7761 6.75 18 6.97386 18 7.25L18 9.25Z"
        fill="currentColor"
      />
      <path
        d="M18 13.25C18 13.5261 17.7761 13.75 17.5 13.75L13.5 13.75C13.2239 13.75 13 13.5261 13 13.25L13 11.25C13 10.9739 13.2239 10.75 13.5 10.75L17.5 10.75C17.7761 10.75 18 10.9739 18 11.25L18 13.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9502 14.75C21.9502 15.9925 20.9427 16.9998 19.7002 17L12.75 17L12.75 19L15 19C15.4142 19 15.75 19.3358 15.75 19.75C15.75 20.1642 15.4142 20.5 15 20.5L9 20.5C8.58579 20.5 8.25 20.1642 8.25 19.75C8.25 19.3358 8.58579 19 9 19L11.25 19L11.25 17L4.29981 17C3.05725 16.9999 2.04981 15.9926 2.04981 14.75L2.04981 5.75C2.04981 4.50742 3.05725 3.5001 4.29981 3.5L19.7002 3.5C20.9427 3.50021 21.9502 4.50749 21.9502 5.75L21.9502 14.75ZM20.4502 5.75C20.4502 5.33592 20.1142 5.00021 19.7002 5L4.29981 5C3.88568 5.0001 3.54981 5.33585 3.54981 5.75L3.54981 14.75C3.54981 15.1642 3.88568 15.4999 4.29981 15.5L19.7002 15.5C20.1142 15.4998 20.4502 15.1641 20.4502 14.75L20.4502 5.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_date = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M18 14C18.5522 14.0001 19 14.4478 19 15V18C18.9999 18.5521 18.5521 18.9999 18 19H15C14.4478 19 14.0001 18.5522 14 18V15C14 14.4477 14.4477 14 15 14H18Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 2.0498C17.4141 2.0499 17.75 2.38565 17.75 2.7998V4.25H20.2002C21.1665 4.25021 21.9502 5.03363 21.9502 6V20.2002C21.95 21.1664 21.1664 21.95 20.2002 21.9502H3.7998C2.83344 21.9502 2.05002 21.1665 2.0498 20.2002V6C2.0498 5.0335 2.83331 4.25 3.7998 4.25H6.25V2.7998C6.25 2.38559 6.58579 2.0498 7 2.0498C7.41413 2.0499 7.75 2.38565 7.75 2.7998V4.25H16.25V2.7998C16.25 2.38559 16.5858 2.0498 17 2.0498ZM3.5498 20.2002C3.55002 20.3381 3.66187 20.4502 3.7998 20.4502H20.2002C20.338 20.45 20.45 20.338 20.4502 20.2002V9H3.5498V20.2002Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_delete = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.35254 10.7646C8.75858 10.6834 9.15395 10.9466 9.23535 11.3525L10.2354 16.3525C10.3166 16.7586 10.0534 17.1539 9.64746 17.2354C9.24142 17.3166 8.84605 17.0534 8.76465 16.6475L7.76465 11.6475C7.68344 11.2414 7.94658 10.8461 8.35254 10.7646Z"
        fill="currentColor"
      />
      <path
        d="M12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V11.5C11.25 11.0858 11.5858 10.75 12 10.75Z"
        fill="currentColor"
      />
      <path
        d="M14.7646 11.3525C14.8461 10.9466 15.2414 10.6834 15.6475 10.7646C16.0534 10.8461 16.3166 11.2414 16.2354 11.6475L15.2354 16.6475C15.1539 17.0534 14.7586 17.3166 14.3525 17.2354C13.9466 17.1539 13.6834 16.7586 13.7646 16.3525L14.7646 11.3525Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 2.0498C13.9664 2.0498 14.7499 2.8334 14.75 3.7998V4.25H20C20.4142 4.25 20.75 4.58579 20.75 5V8C20.75 8.41421 20.4142 8.75 20 8.75H19.6445L17.999 19.6123C17.7952 20.9565 16.6398 21.9502 15.2803 21.9502H8.71973C7.36018 21.9502 6.20481 20.9565 6.00098 19.6123L4.35547 8.75H4C3.58579 8.75 3.25 8.41421 3.25 8V5C3.25 4.58579 3.58579 4.25 4 4.25H8.75V3.7998C8.75011 2.8334 9.53357 2.0498 10.5 2.0498H13ZM7.48438 19.3877C7.57717 19.9985 8.10188 20.4502 8.71973 20.4502H15.2803C15.8981 20.4502 16.4228 19.9985 16.5156 19.3877L18.1279 8.75H5.87207L7.48438 19.3877ZM4.75 7.25H19.25V5.75H4.75V7.25ZM10.5 3.5498C10.362 3.5498 10.2501 3.66182 10.25 3.7998V4.25H13.25V3.7998C13.2499 3.66182 13.138 3.5498 13 3.5498H10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_dot = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx="12" cy="12" r="6" fill="currentColor" />
    </svg>
  );
};

const Icon_download = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M21.2002 19.3501C21.6142 19.3503 21.9502 19.686 21.9502 20.1001C21.9502 20.5142 21.6142 20.8499 21.2002 20.8501H2.7998C2.38568 20.85 2.0498 20.5142 2.0498 20.1001C2.0498 19.6859 2.38568 19.3502 2.7998 19.3501H21.2002Z"
        fill="currentColor"
      />
      <path
        d="M12 3.1499C12.4142 3.1499 12.7499 3.48577 12.75 3.8999V15.0581L17.4639 10.2329C17.7533 9.93678 18.2281 9.93094 18.5244 10.2202C18.8205 10.5096 18.8254 10.9845 18.5361 11.2808L12.5361 17.4243C12.395 17.5686 12.2018 17.6499 12 17.6499C11.7982 17.6499 11.605 17.5686 11.4639 17.4243L5.46387 11.2808C5.17461 10.9845 5.17951 10.5096 5.47559 10.2202C5.77186 9.93094 6.24673 9.93678 6.53613 10.2329L11.25 15.0581V3.8999C11.2501 3.48577 11.5858 3.1499 12 3.1499Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_drag = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M21.2002 16.25C21.6142 16.2502 21.9502 16.5859 21.9502 17C21.9502 17.4141 21.6142 17.7498 21.2002 17.75H2.7998C2.38568 17.7499 2.0498 17.4142 2.0498 17C2.0498 16.5858 2.38568 16.2501 2.7998 16.25H21.2002Z"
        fill="currentColor"
      />
      <path
        d="M21.2002 11.25C21.6142 11.2502 21.9502 11.5859 21.9502 12C21.9502 12.4141 21.6142 12.7498 21.2002 12.75H2.7998C2.38568 12.7499 2.0498 12.4142 2.0498 12C2.0498 11.5858 2.38568 11.2501 2.7998 11.25H21.2002Z"
        fill="currentColor"
      />
      <path
        d="M21.2002 6.25C21.6142 6.25021 21.9502 6.58592 21.9502 7C21.9502 7.41408 21.6142 7.74979 21.2002 7.75H2.7998C2.38568 7.7499 2.0498 7.41415 2.0498 7C2.0498 6.58585 2.38568 6.2501 2.7998 6.25H21.2002Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_edit = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9649 2.33392C16.4231 1.96031 17.0849 1.96031 17.5431 2.33392L17.6378 2.41985L21.5802 6.36321C22.0683 6.85136 22.0683 7.64265 21.5802 8.13079L8.13095 21.58C7.89664 21.8143 7.57852 21.9461 7.24716 21.9462H3.3038C2.61353 21.9461 2.0538 21.3865 2.0538 20.6962V16.7538C2.05388 16.4225 2.1857 16.1044 2.42001 15.8701L15.8702 2.41985L15.9649 2.33392ZM3.5538 16.8574V20.4462H7.14365L17.6856 9.90325L14.0958 6.31341L3.5538 16.8574ZM15.1563 5.25286L18.7462 8.84271L20.3429 7.24603L16.753 3.65716L15.1563 5.25286Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_etc = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.5 10.5C4.32843 10.5 5 11.1716 5 12C5 12.8284 4.32843 13.5 3.5 13.5C2.67157 13.5 2 12.8284 2 12C2 11.1716 2.67157 10.5 3.5 10.5Z"
        fill="currentColor"
      />
      <path
        d="M12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5Z"
        fill="currentColor"
      />
      <path
        d="M20.5 10.5C21.3284 10.5 22 11.1716 22 12C22 12.8284 21.3284 13.5 20.5 13.5C19.6716 13.5 19 12.8284 19 12C19 11.1716 19.6716 10.5 20.5 10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_event = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17 2C17.5523 2 18 2.44772 18 3V4H20C21.1046 4 22 4.89543 22 6V19.25C22 20.7688 20.7688 22 19.25 22H4.75C3.23122 22 2 20.7688 2 19.25V6C2 4.89543 2.89543 4 4 4H6V3C6 2.44772 6.44772 2 7 2C7.55228 2 8 2.44772 8 3V4H16V3C16 2.44772 16.4477 2 17 2ZM3.5 19.25C3.5 19.9404 4.05964 20.5 4.75 20.5H19.25C19.9404 20.5 20.5 19.9404 20.5 19.25V9H3.5V19.25ZM11.5244 11.4639C11.6741 11.0032 12.3259 11.0032 12.4756 11.4639L13.0107 13.1094C13.0777 13.3153 13.2697 13.4551 13.4863 13.4551H15.2168C15.7008 13.4554 15.9021 14.0746 15.5107 14.3594L14.1104 15.377C13.9352 15.5043 13.8618 15.7296 13.9287 15.9355L14.4639 17.582C14.6129 18.0423 14.086 18.4249 13.6943 18.1406L12.2939 17.123C12.1187 16.9958 11.8813 16.9958 11.7061 17.123L10.3057 18.1406C9.91399 18.4249 9.3871 18.0423 9.53613 17.582L10.0713 15.9355C10.1382 15.7296 10.0648 15.5043 9.88965 15.377L8.48926 14.3594C8.09789 14.0746 8.29922 13.4554 8.7832 13.4551H10.5137C10.7303 13.4551 10.9223 13.3153 10.9893 13.1094L11.5244 11.4639Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_global = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9.125 16.8799C9.64032 17.9189 10.337 18.9863 11.25 20.0742V17.1523C10.7225 17.128 10.2057 17.0736 9.70215 16.9902C9.50749 16.958 9.31532 16.92 9.125 16.8799ZM14.9121 16.8027C14.1771 16.9777 13.4556 17.0859 12.75 17.1348V20.0742C13.6855 18.9595 14.3932 17.8659 14.9121 16.8027ZM3.91699 14.6318C4.75232 17.1991 6.77577 19.2278 9.33887 20.0723C8.406 18.8112 7.72371 17.5643 7.25195 16.3447C6.00154 15.892 4.88041 15.2884 3.91699 14.6318ZM20.1475 14.4229C19.0161 15.1944 17.8973 15.7811 16.7998 16.21C16.3267 17.4726 15.6276 18.7645 14.6602 20.0723C17.2928 19.2052 19.3559 17.0889 20.1475 14.4229ZM8.27148 9.03809C8.18964 9.33885 8.11948 9.64601 8.0625 9.95898C7.77607 11.5325 7.81939 13.2821 8.41895 15.1494C8.91034 15.2977 9.41979 15.4225 9.94727 15.5098C10.3696 15.5797 10.8044 15.6272 11.25 15.6504V9.4502C10.1743 9.41607 9.17556 9.26314 8.27148 9.03809ZM15.6914 8.91309C14.6717 9.19136 13.6883 9.35314 12.75 9.41992V15.6309C13.6693 15.5589 14.6262 15.3728 15.6133 15.0449C16.1814 13.2167 16.2186 11.5032 15.9375 9.95898C15.8726 9.60231 15.7884 9.25381 15.6914 8.91309ZM4.73828 7.5791C3.95246 8.86713 3.5 10.3808 3.5 12C3.5 12.1441 3.50268 12.2874 3.50977 12.4297C4.3541 13.1664 5.43081 13.9024 6.68555 14.4873C6.30929 12.8054 6.31335 11.1932 6.58691 9.69043C6.65463 9.31845 6.73875 8.95434 6.83691 8.59863C6.01603 8.29416 5.30985 7.93704 4.73828 7.5791ZM19.2168 7.51172C18.5072 7.88586 17.8075 8.19668 17.1211 8.45312C17.2371 8.85494 17.3361 9.26747 17.4131 9.69043C17.6782 11.1467 17.6895 12.7055 17.3477 14.3311C18.3736 13.8258 19.4241 13.1586 20.4922 12.3008C20.4957 12.2009 20.5 12.1007 20.5 12C20.5 10.3518 20.0288 8.81454 19.2168 7.51172ZM11.25 3.74707C10.3153 4.76493 9.39782 6.08022 8.75977 7.61426C9.51644 7.7938 10.3507 7.91795 11.25 7.94922V3.74707ZM12.75 7.91602C13.5277 7.85413 14.3419 7.71825 15.1865 7.49512C14.5512 6.01251 13.6602 4.73821 12.75 3.74707V7.91602ZM9.09863 4.00781C7.75188 4.49683 6.56506 5.31783 5.63379 6.37012C6.09381 6.64946 6.66061 6.93072 7.31934 7.17773C7.79595 5.99524 8.4203 4.93108 9.09863 4.00781ZM14.9004 4.00781C15.5519 4.89444 16.1543 5.91046 16.623 7.03711C17.1727 6.83088 17.7316 6.58427 18.2998 6.29492C17.3786 5.27832 16.2154 4.48515 14.9004 4.00781Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_helpFill = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 15.75C11.4477 15.75 11 16.1977 11 16.75C11 17.3023 11.4477 17.75 12 17.75C12.5523 17.75 13 17.3023 13 16.75C13 16.1977 12.5523 15.75 12 15.75ZM12 5.625C10.5844 5.625 9.61212 6.17361 9.01172 6.93164C8.43765 7.65648 8.25 8.51255 8.25 9.10254C8.25014 9.51663 8.58588 9.85254 9 9.85254C9.41412 9.85254 9.74986 9.51663 9.75 9.10254C9.75 8.78348 9.86166 8.27478 10.1875 7.86328C10.4871 7.485 11.0157 7.125 12 7.125C12.9843 7.125 13.5129 7.485 13.8125 7.86328C14.1383 8.27478 14.25 8.78348 14.25 9.10254C14.2499 9.68017 13.9247 10.6843 12.7969 10.9844C12.0595 11.1807 11.2502 11.8236 11.25 12.8291V13.875C11.25 14.2892 11.5858 14.625 12 14.625C12.4142 14.625 12.75 14.2892 12.75 13.875V12.8291C12.7501 12.7716 12.7715 12.7043 12.8428 12.6279C12.9188 12.5466 13.039 12.4719 13.1826 12.4336C15.2172 11.8923 15.7499 10.0616 15.75 9.10254C15.75 8.51255 15.5624 7.65648 14.9883 6.93164C14.3879 6.17361 13.4156 5.625 12 5.625Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_helpOutline = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 15.75C12.5522 15.7501 13 16.1978 13 16.75C12.9999 17.3021 12.5521 17.7499 12 17.75C11.4478 17.75 11.0001 17.3022 11 16.75C11 16.1977 11.4477 15.75 12 15.75Z"
        fill="currentColor"
      />
      <path
        d="M12 5.625C13.4155 5.62505 14.3879 6.17365 14.9883 6.93164C15.5622 7.65643 15.75 8.51261 15.75 9.10254C15.7498 10.0616 15.2169 11.8923 13.1826 12.4336C13.039 12.4719 12.9188 12.5466 12.8428 12.6279C12.7715 12.7043 12.7501 12.7716 12.75 12.8291V13.875C12.7499 14.2891 12.4141 14.6249 12 14.625C11.5859 14.625 11.2501 14.2891 11.25 13.875V12.8291C11.2502 11.8236 12.0595 11.1807 12.7969 10.9844C13.9244 10.6843 14.2498 9.68018 14.25 9.10254C14.25 8.78353 14.1382 8.27475 13.8125 7.86328C13.5129 7.48502 12.9842 7.12504 12 7.125C11.0157 7.125 10.4871 7.485 10.1875 7.86328C9.86168 8.27478 9.75 8.78348 9.75 9.10254C9.74975 9.51648 9.41397 9.85244 9 9.85254C8.58594 9.85254 8.25025 9.51654 8.25 9.10254C8.25 8.51256 8.43767 7.65647 9.01172 6.93164C9.61212 6.17361 10.5844 5.625 12 5.625Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.0498C18.0474 1.04991 22.9502 5.95255 22.9502 12C22.9501 18.0474 18.0474 22.9501 12 22.9502C5.95255 22.9502 1.04991 18.0474 1.0498 12C1.0498 5.95248 5.95248 1.0498 12 1.0498ZM12 2.5498C6.78091 2.5498 2.5498 6.78091 2.5498 12C2.54991 17.219 6.78097 21.4502 12 21.4502C17.2189 21.4501 21.4501 17.2189 21.4502 12C21.4502 6.78097 17.219 2.54991 12 2.5498Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_history = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.03158 6.42485C6.84851 2.27052 12.4085 0.83851 16.9261 3.26665C21.7495 5.85932 23.5579 11.871 20.9652 16.6944C18.3724 21.5175 12.3607 23.326 7.53744 20.7334C6.16856 19.9976 5.04122 18.9844 4.18881 17.8008C3.94694 17.4648 4.02287 16.996 4.35873 16.754C4.6948 16.512 5.16452 16.5879 5.40658 16.9239C6.1288 17.9266 7.08352 18.7865 8.24741 19.4122C12.3409 21.6125 17.4433 20.0777 19.6439 15.9844C21.8443 11.8908 20.3098 6.78842 16.2162 4.58794C12.319 2.49324 7.50996 3.78468 5.15854 7.44536L7.62826 7.32426C8.04197 7.30373 8.39484 7.62247 8.41537 8.03618C8.43579 8.44979 8.11611 8.80178 7.70248 8.82231L3.85287 9.01274C3.55369 9.02734 3.27959 8.86299 3.1478 8.60258L3.09994 8.48637L1.88412 4.55278C1.76185 4.15702 1.98446 3.73658 2.38022 3.6143C2.77581 3.49235 3.19447 3.71389 3.31674 4.10942L4.03158 6.42485Z"
        fill="currentColor"
      />
      <path
        d="M12.3167 6.76469C12.7309 6.76469 13.0667 7.10055 13.0667 7.51469V12.0547C13.0668 12.3134 13.1468 12.5663 13.2962 12.7774L14.929 15.0811C15.1684 15.4191 15.0883 15.8876 14.7503 16.127C14.4123 16.3662 13.9438 16.2862 13.7044 15.9483L12.0726 13.6446C11.7436 13.18 11.5668 12.624 11.5667 12.0547V7.51469C11.5668 7.10068 11.9028 6.7649 12.3167 6.76469Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_image = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5.25C17.5188 5.25 18.75 6.48122 18.75 8C18.75 9.51878 17.5188 10.75 16 10.75C14.4812 10.75 13.25 9.51878 13.25 8C13.25 6.48122 14.4812 5.25 16 5.25ZM16 6.75C15.3096 6.75 14.75 7.30964 14.75 8C14.75 8.69036 15.3096 9.25 16 9.25C16.6904 9.25 17.25 8.69036 17.25 8C17.25 7.30964 16.6904 6.75 16 6.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2002 2.0498C20.7187 2.05002 21.9501 3.28123 21.9502 4.7998V19.2002C21.95 20.7187 20.7187 21.95 19.2002 21.9502H4.7998C3.28124 21.9501 2.05001 20.7187 2.0498 19.2002V4.7998C2.0499 3.28117 3.28116 2.0499 4.7998 2.0498H19.2002ZM4.7998 3.5498C4.10959 3.5499 3.5499 4.10959 3.5498 4.7998V11.8037L6.76465 8.70801C7.1683 8.31972 7.81224 8.33867 8.19238 8.75L14.9121 16.0293C15.2496 16.3947 15.8042 16.457 16.2139 16.1748L19.4326 13.9561C19.7591 13.731 20.1435 13.7318 20.4502 13.8867V4.7998C20.4501 4.10966 19.8903 3.55002 19.2002 3.5498H4.7998Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_inline = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.0801 2.0498C11.4941 2.04995 11.83 2.38577 11.8301 2.7998C11.8301 3.21393 11.4942 3.54966 11.0801 3.5498H3.7998C3.66191 3.54994 3.5499 3.6619 3.5498 3.7998V20.2002C3.55001 20.338 3.66197 20.4501 3.7998 20.4502H20.2002C20.338 20.45 20.45 20.338 20.4502 20.2002V12.9199C20.4503 12.5059 20.7862 12.1701 21.2002 12.1699C21.6142 12.1701 21.9501 12.5059 21.9502 12.9199V20.2002C21.95 21.1664 21.1664 21.95 20.2002 21.9502H3.7998C2.83355 21.9501 2.05001 21.1664 2.0498 20.2002V3.7998C2.0499 2.83347 2.83348 2.04994 3.7998 2.0498H11.0801Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3252 4.66699C19.5765 4.21659 20.0655 4.07962 20.4551 4.17578C20.858 4.27538 21.248 4.65457 21.2051 5.21094L21.1475 5.79199C20.9808 7.18748 20.5611 8.83543 19.5479 10.2197C18.424 11.755 16.6276 12.8864 13.8779 13.0596V15.8457C13.8779 16.7061 12.8828 17.1403 12.2539 16.6279L12.1328 16.5127L7.59082 11.4375C7.25096 11.0578 7.25096 10.4832 7.59082 10.1035L12.1328 5.0293C12.7449 4.34543 13.8779 4.77847 13.8779 5.69629V8.55957C15.0735 8.59246 17.4617 8.00699 19.3252 4.66699ZM9.00684 10.7715L12.3779 14.5381V12.583C12.3781 12.0114 12.8468 11.5923 13.3662 11.5811C15.9616 11.5247 17.4486 10.5489 18.3379 9.33398C18.787 8.72044 19.0992 8.02407 19.3135 7.31152C17.0812 9.91545 14.4914 10.247 13.166 9.9873C12.6634 9.8888 12.3779 9.44604 12.3779 9.01953V7.00488L9.00684 10.7715Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_launcher = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5 18C5.55228 18 6 18.4477 6 19V21C6 21.5523 5.55228 22 5 22H3C2.44772 22 2 21.5523 2 21V19C2 18.4477 2.44772 18 3 18H5Z"
        fill="currentColor"
      />
      <path
        d="M13 18C13.5523 18 14 18.4477 14 19V21C14 21.5523 13.5523 22 13 22H11C10.4477 22 10 21.5523 10 21V19C10 18.4477 10.4477 18 11 18H13Z"
        fill="currentColor"
      />
      <path
        d="M21 18C21.5523 18 22 18.4477 22 19V21C22 21.5523 21.5523 22 21 22H19C18.4477 22 18 21.5523 18 21V19C18 18.4477 18.4477 18 19 18H21Z"
        fill="currentColor"
      />
      <path
        d="M5 10C5.55228 10 6 10.4477 6 11V13C6 13.5523 5.55228 14 5 14H3C2.44772 14 2 13.5523 2 13V11C2 10.4477 2.44772 10 3 10H5Z"
        fill="currentColor"
      />
      <path
        d="M13 10C13.5523 10 14 10.4477 14 11V13C14 13.5523 13.5523 14 13 14H11C10.4477 14 10 13.5523 10 13V11C10 10.4477 10.4477 10 11 10H13Z"
        fill="currentColor"
      />
      <path
        d="M21 10C21.5523 10 22 10.4477 22 11V13C22 13.5523 21.5523 14 21 14H19C18.4477 14 18 13.5523 18 13V11C18 10.4477 18.4477 10 19 10H21Z"
        fill="currentColor"
      />
      <path
        d="M5 2C5.55228 2 6 2.44772 6 3V5C6 5.55228 5.55228 6 5 6H3C2.44772 6 2 5.55228 2 5V3C2 2.44772 2.44772 2 3 2H5Z"
        fill="currentColor"
      />
      <path
        d="M13 2C13.5523 2 14 2.44772 14 3V5C14 5.55228 13.5523 6 13 6H11C10.4477 6 10 5.55228 10 5V3C10 2.44772 10.4477 2 11 2H13Z"
        fill="currentColor"
      />
      <path
        d="M21 2C21.5523 2 22 2.44772 22 3V5C22 5.55228 21.5523 6 21 6H19C18.4477 6 18 5.55228 18 5V3C18 2.44772 18.4477 2 19 2H21Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_leftRight = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.46594 12.5001C6.7421 12.1916 7.21587 12.1655 7.52454 12.4415C7.83288 12.7177 7.85911 13.1915 7.58313 13.5001L4.67688 16.7501H21.0001C21.4142 16.7502 21.7501 17.086 21.7501 17.5001C21.75 17.9142 21.4142 18.25 21.0001 18.2501H4.67688L7.58313 21.5001C7.859 21.8088 7.83295 22.2826 7.52454 22.5587C7.21592 22.8347 6.74212 22.8085 6.46594 22.5001L2.44153 18.0001C2.18693 17.7154 2.18693 17.2848 2.44153 17.0001L6.46594 12.5001Z"
        fill="currentColor"
      />
      <path
        d="M16.4757 1.44153C16.7844 1.16552 17.2582 1.19163 17.5343 1.50013L21.5587 6.00013C21.8132 6.28481 21.8132 6.71549 21.5587 7.00013L17.5343 11.5001C17.2582 11.8086 16.7844 11.8346 16.4757 11.5587C16.1672 11.2826 16.1411 10.8088 16.4171 10.5001L19.3234 7.25013H3.00012C2.58596 7.25013 2.2502 6.91428 2.25012 6.50013C2.25012 6.08591 2.58591 5.75013 3.00012 5.75013H19.3234L16.4171 2.50013C16.1411 2.19146 16.1672 1.71769 16.4757 1.44153Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_line = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.25 13C4.66421 13 5 13.3358 5 13.75V21.25C5 21.6642 4.66421 22 4.25 22H2.75C2.33579 22 2 21.6642 2 21.25V13.75C2 13.3358 2.33579 13 2.75 13H4.25Z"
        fill="currentColor"
      />
      <path
        d="M12.75 13C13.1642 13 13.5 13.3358 13.5 13.75V21.25C13.5 21.6642 13.1642 22 12.75 22H11.25C10.8358 22 10.5 21.6642 10.5 21.25V13.75C10.5 13.3358 10.8358 13 11.25 13H12.75Z"
        fill="currentColor"
      />
      <path
        d="M4.25 2C4.66421 2 5 2.33579 5 2.75V10.25C5 10.6642 4.66421 11 4.25 11H2.75C2.33579 11 2 10.6642 2 10.25V2.75C2 2.33579 2.33579 2 2.75 2H4.25Z"
        fill="currentColor"
      />
      <path
        d="M12.75 2C13.1642 2 13.5 2.33579 13.5 2.75V10.25C13.5 10.6642 13.1642 11 12.75 11H11.25C10.8358 11 10.5 10.6642 10.5 10.25V2.75C10.5 2.33579 10.8358 2 11.25 2H12.75Z"
        fill="currentColor"
      />
      <path
        d="M21.25 2C21.6642 2 22 2.33579 22 2.75V10.25C22 10.6642 21.6642 11 21.25 11H19.75C19.3358 11 19 10.6642 19 10.25V2.75C19 2.33579 19.3358 2 19.75 2H21.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_location = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.9583 22.5159C12.4583 23.1614 11.5 23.1614 11 22.5159C8.875 19.7188 4 13.0489 4 9.2621C4 4.70073 7.58333 1 12 1C16.4167 1 20 4.70073 20 9.2621C20 13.0489 15.125 19.7188 12.9583 22.5159ZM12 12.0161C13.4583 12.0161 14.6667 10.8112 14.6667 9.2621C14.6667 7.75599 13.4583 6.50807 12 6.50807C10.5 6.50807 9.33333 7.75599 9.33333 9.2621C9.33333 10.8112 10.5 12.0161 12 12.0161Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_logout = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.7899 2.0498C13.7563 2.0498 14.5398 2.83339 14.5399 3.7998V7.70605C14.5399 8.12027 14.2041 8.45605 13.7899 8.45605C13.3757 8.45596 13.0399 8.12021 13.0399 7.70605V3.7998C13.0398 3.66182 12.9279 3.5498 12.7899 3.5498H3.78986C3.65193 3.5499 3.53995 3.66188 3.53986 3.7998V20.2002C3.54007 20.338 3.652 20.4501 3.78986 20.4502H12.7899C12.9278 20.4502 13.0396 20.3381 13.0399 20.2002V16.5996C13.0401 16.1856 13.3759 15.8497 13.7899 15.8496C14.2039 15.8496 14.5397 16.1856 14.5399 16.5996V20.2002C14.5396 21.1665 13.7562 21.9502 12.7899 21.9502H3.78986C2.82357 21.9501 2.04007 21.1665 2.03986 20.2002V3.7998C2.03995 2.83345 2.8235 2.0499 3.78986 2.0498H12.7899Z"
        fill="currentColor"
      />
      <path
        d="M16.5877 6.58594C16.9098 6.3258 17.3821 6.37537 17.6424 6.69727L21.7938 11.8379L21.867 11.9473C22.0127 12.2111 21.9874 12.5428 21.7918 12.7832L17.658 17.8633C17.3966 18.1846 16.9236 18.234 16.6024 17.9727C16.2812 17.7113 16.2329 17.2383 16.494 16.917L19.6356 13.0557L8.6004 13.0381C8.18644 13.0372 7.85084 12.7011 7.85138 12.2871C7.85215 11.873 8.18925 11.5375 8.60333 11.5381L19.6385 11.5557L16.4754 7.64062C16.2153 7.31848 16.2658 6.84621 16.5877 6.58594Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_minus = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20 11.25C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H20Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_monitor = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9502 14.75C21.9502 15.9925 20.9426 16.9998 19.7002 17L12.75 17L12.75 19H15C15.4142 19 15.75 19.3358 15.75 19.75C15.75 20.1642 15.4142 20.5 15 20.5L8.99997 20.5C8.58576 20.5 8.24997 20.1642 8.24997 19.75C8.24997 19.3358 8.58576 19 8.99997 19H11.25L11.25 17H4.29977C3.05722 16.9999 2.04977 15.9926 2.04977 14.75L2.04977 5.75C2.04978 4.50742 3.05722 3.5001 4.29977 3.5L19.7002 3.5C20.9426 3.50021 21.9502 4.50749 21.9502 5.75L21.9502 14.75ZM20.4502 5.75C20.4502 5.33592 20.1142 5.00021 19.7002 5L4.29977 5C3.88565 5.0001 3.54978 5.33585 3.54977 5.75L3.54977 14.75C3.54977 15.1642 3.88565 15.4999 4.29977 15.5L19.7002 15.5C20.1142 15.4998 20.4502 15.1641 20.4502 14.75L20.4502 5.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_new = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20 2C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4C2 2.89543 2.89543 2 4 2H20ZM7.5 6.75V17.25H9.99902V11.082H10.0713L14.374 17.25H16.5V6.75H14.0059V12.9072H13.918L9.66211 6.75H7.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_notificationFill = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 15.5C11.4477 15.5 11 15.9477 11 16.5C11 17.0523 11.4477 17.5 12 17.5C12.5523 17.5 13 17.0523 13 16.5C13 15.9477 12.5523 15.5 12 15.5ZM12 6.375C11.5858 6.375 11.25 6.71079 11.25 7.125V13.125C11.25 13.5392 11.5858 13.875 12 13.875C12.4142 13.875 12.75 13.5392 12.75 13.125V7.125C12.75 6.71079 12.4142 6.375 12 6.375Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_notificationOutline = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 15.5C12.5523 15.5 13 15.9477 13 16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5C11 15.9477 11.4477 15.5 12 15.5Z"
        fill="currentColor"
      />
      <path
        d="M12 6.375C12.4142 6.375 12.75 6.71079 12.75 7.125V13.125C12.75 13.5392 12.4142 13.875 12 13.875C11.5858 13.875 11.25 13.5392 11.25 13.125V7.125C11.25 6.71079 11.5858 6.375 12 6.375Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.0498C18.0474 1.04991 22.9501 5.95264 22.9502 12C22.9501 18.0474 18.0474 22.9501 12 22.9502C5.95263 22.9501 1.04991 18.0474 1.0498 12C1.04991 5.95263 5.95263 1.0499 12 1.0498ZM12 2.5498C6.78106 2.5499 2.54991 6.78106 2.5498 12C2.54991 17.2189 6.78106 21.4501 12 21.4502C17.2189 21.4501 21.4501 17.2189 21.4502 12C21.4501 6.78107 17.2189 2.54991 12 2.5498Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_notion = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.44865 5.18238C6.0973 5.71282 6.33977 5.67237 7.5583 5.58993L19.0378 4.89616C19.2819 4.89616 19.0795 4.65194 18.9977 4.61149L17.0903 3.22239C16.7259 2.93617 16.2394 2.60951 15.3066 2.69195L4.18996 3.50861C3.78533 3.54906 3.70347 3.75283 3.86564 3.91616L5.44865 5.18238ZM6.13745 7.87658V20.0425C6.13745 20.6958 6.46178 20.9416 7.19228 20.9012L19.81 20.1654C20.539 20.1249 20.6208 19.6754 20.6208 19.145V7.05992C20.6208 6.53103 20.4185 6.24326 19.9722 6.2837L6.7861 7.05992C6.29961 7.10036 6.13745 7.34614 6.13745 7.87658ZM18.5931 8.52991C18.6734 8.89702 18.5931 9.26413 18.227 9.30613L17.6185 9.42746V18.4092C17.0919 18.6954 16.6039 18.8603 16.1977 18.8603C15.549 18.8603 15.3869 18.655 14.9004 18.0421L10.9236 11.7546V17.8383L12.1822 18.1245C12.1822 18.1245 12.1822 18.8587 11.1676 18.8587L8.36911 19.0221C8.28726 18.8587 8.36911 18.4512 8.65328 18.3687L9.38224 18.1665V10.1212L8.37066 10.0403C8.2888 9.67324 8.49112 9.1428 9.05946 9.1008L12.0618 8.89858L16.2008 15.267V9.63279L15.1459 9.5099C15.0641 9.06035 15.3884 8.73369 15.7946 8.69324L18.5946 8.52991H18.5931ZM3.25714 2.40573L14.8201 1.54862C16.2394 1.42418 16.6039 1.50818 17.4965 2.16151L21.1876 4.77482C21.7977 5.22282 22 5.34571 22 5.83571V20.1654C22 21.0645 21.6757 21.5965 20.539 21.6758L7.11197 22.4925C6.25946 22.5345 5.85328 22.4116 5.40695 21.8392L2.6888 18.2878C2.20232 17.6345 2 17.1445 2 16.5721V3.83372C2 3.0995 2.32432 2.48662 3.25714 2.40573Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_outline = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.0801 2.0498C11.4942 2.04995 11.8301 2.38568 11.8301 2.7998C11.8301 3.21393 11.4942 3.54966 11.0801 3.5498H3.7998C3.66173 3.5498 3.5498 3.66173 3.5498 3.7998V20.2002C3.55001 20.3381 3.66186 20.4502 3.7998 20.4502H20.2002C20.338 20.45 20.45 20.338 20.4502 20.2002V12.9199C20.4502 12.5057 20.786 12.1699 21.2002 12.1699C21.6142 12.1701 21.9502 12.5058 21.9502 12.9199V20.2002C21.95 21.1664 21.1664 21.95 20.2002 21.9502H3.7998C2.83344 21.9502 2.05001 21.1665 2.0498 20.2002V3.7998C2.0498 2.83331 2.83331 2.0498 3.7998 2.0498H11.0801Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6221 3.6543C14.6221 2.7939 15.6172 2.35966 16.2461 2.87207L16.3672 2.9873L20.9092 8.0625C21.2489 8.44219 21.249 9.01686 20.9092 9.39648L16.3672 14.4707C15.7551 15.1545 14.6222 14.7214 14.6221 13.8037V10.9404C13.4265 10.9075 11.0383 11.493 9.1748 14.833C8.92355 15.2833 8.43442 15.4203 8.04492 15.3242C7.64205 15.2246 7.2521 14.8453 7.29492 14.2891L7.35254 13.708C7.51917 12.3125 7.93893 10.6646 8.95215 9.28027C10.076 7.74497 11.8724 6.61358 14.6221 6.44043V3.6543ZM16.1221 6.91699C16.1218 7.48846 15.653 7.90758 15.1338 7.91895C12.5384 7.97534 11.0514 8.95111 10.1621 10.166C9.71303 10.7796 9.40079 11.4759 9.18652 12.1885C11.4188 9.58455 14.0086 9.253 15.334 9.5127C15.8365 9.61128 16.1221 10.054 16.1221 10.4805V12.4951L19.4932 8.72852L16.1221 4.96191V6.91699Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_pageEdit = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.0801 2.0498C11.4941 2.04995 11.83 2.38577 11.8301 2.7998C11.8301 3.21393 11.4942 3.54966 11.0801 3.5498H3.7998C3.66188 3.54991 3.5499 3.66188 3.5498 3.7998V20.2002C3.55001 20.338 3.66195 20.4501 3.7998 20.4502H20.2002C20.338 20.45 20.45 20.338 20.4502 20.2002V12.9199C20.4503 12.5059 20.7861 12.17 21.2002 12.1699C21.6142 12.1701 21.9501 12.5059 21.9502 12.9199V20.2002C21.95 21.1664 21.1664 21.95 20.2002 21.9502H3.7998C2.83353 21.9501 2.05001 21.1665 2.0498 20.2002V3.7998C2.0499 2.83346 2.83346 2.04991 3.7998 2.0498H11.0801Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2109 2.7373C17.7019 2.33686 18.4261 2.36563 18.8838 2.82324L21.1768 5.11621C21.6649 5.60436 21.6649 6.39564 21.1768 6.88379L12.6768 15.3838C12.4424 15.6182 12.1245 15.75 11.793 15.75H9.5C8.80964 15.75 8.25 15.1904 8.25 14.5V12.207C8.25002 11.8755 8.38181 11.5576 8.61621 11.3232L17.1162 2.82324L17.2109 2.7373ZM9.75 12.3105V14.25H11.6895L19.9395 6L18 4.06055L9.75 12.3105Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_pageMove = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.0303 2C11.4443 2.00015 11.7802 2.33596 11.7803 2.75C11.7803 3.16412 11.4444 3.49985 11.0303 3.5H3.75C3.61208 3.50011 3.5001 3.61208 3.5 3.75V20.1504C3.50021 20.2882 3.61215 20.4003 3.75 20.4004H20.1504C20.2882 20.4002 20.4002 20.2882 20.4004 20.1504V12.8701C20.4005 12.4561 20.7363 12.1202 21.1504 12.1201C21.5644 12.1203 21.9003 12.4561 21.9004 12.8701V20.1504C21.9002 21.1166 21.1166 21.9002 20.1504 21.9004H3.75C2.78372 21.9003 2.00021 21.1166 2 20.1504V3.75C2.0001 2.78365 2.78365 2.00011 3.75 2H11.0303Z"
        fill="currentColor"
      />
      <path
        d="M19.9502 3.2002C20.3644 3.2002 20.7002 3.53598 20.7002 3.9502V8.5332C20.7002 8.94742 20.3644 9.2832 19.9502 9.2832C19.536 9.2832 19.2002 8.94742 19.2002 8.5332V5.76074L9.48047 15.4805C9.18758 15.7734 8.71282 15.7734 8.41992 15.4805C8.12703 15.1876 8.12703 14.7128 8.41992 14.4199L18.1396 4.7002H14.4502C14.036 4.7002 13.7002 4.36441 13.7002 3.9502C13.7002 3.53598 14.036 3.2002 14.4502 3.2002H19.9502Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_pdf = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1797 6.87695C11.4061 6.82573 11.6711 6.86636 11.875 7.06543C11.9347 7.12378 11.9793 7.19655 12.0039 7.27637C12.4216 8.63633 12.3322 10.08 11.9766 11.4404C12.1014 11.6056 12.2402 11.7758 12.3955 11.9492C12.7514 12.3465 13.0857 12.6781 13.3965 12.9541C14.1016 12.8052 14.7041 12.7601 15.2148 12.792C16.4346 12.8682 17.1997 13.3953 17.4629 14.0371C17.5303 14.2016 17.5046 14.3901 17.3965 14.5312C17.0163 15.0263 16.2645 15.3668 15.2656 15.1533C14.6465 15.021 13.9371 14.6791 13.1387 14.0439C12.3609 14.2497 11.4279 14.5925 10.3203 15.1289C9.71521 16.0649 9.05595 16.8354 8.48535 17.3076C8.18934 17.5525 7.86476 17.763 7.55078 17.832C7.38638 17.8681 7.17884 17.8751 6.97754 17.7773C6.76533 17.6741 6.6383 17.4923 6.57422 17.3047C6.41329 16.8328 6.53139 16.3944 6.76562 16.041C6.99028 15.7024 7.33148 15.4202 7.68359 15.1924C8.30393 14.7911 9.06997 14.4854 9.65918 14.3018C10.1517 13.4941 10.5887 12.5773 10.8848 11.625C10.0705 10.3811 9.89538 9.2681 10.0508 8.41504C10.1465 7.89052 10.3704 7.45813 10.6523 7.18262C10.7911 7.0472 10.9703 6.92448 11.1797 6.87695ZM8.22656 16.0322C7.92821 16.2253 7.71507 16.4174 7.59863 16.5928C7.55409 16.6599 7.52902 16.7208 7.51465 16.7754C7.60106 16.7255 7.71281 16.6496 7.84766 16.5381C8.05763 16.3643 8.29203 16.1303 8.53809 15.8486C8.43046 15.9074 8.32518 15.9684 8.22656 16.0322ZM14.5391 13.7949C14.9007 14.0019 15.2125 14.1197 15.4746 14.1758C15.8409 14.2541 16.1087 14.2138 16.2959 14.1387C16.0903 13.9839 15.7376 13.8266 15.1523 13.79C14.9689 13.7786 14.7646 13.7788 14.5391 13.7949ZM11.6143 12.5732C11.4727 12.9491 11.3163 13.3152 11.1465 13.665C11.5386 13.5058 11.9101 13.3714 12.2607 13.2588C12.0623 13.0623 11.8592 12.8481 11.6514 12.6162C11.6387 12.6021 11.6267 12.5873 11.6143 12.5732ZM11.1855 8.13574C11.1255 8.25337 11.0695 8.40582 11.0352 8.59375C10.9666 8.96992 10.9859 9.48657 11.2217 10.1123C11.3075 9.4441 11.3052 8.7772 11.1855 8.13574Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1592 2.0498C14.6213 2.0499 15.0648 2.23283 15.3926 2.55859L19.4336 6.57422C19.764 6.90262 19.9501 7.34957 19.9502 7.81543V20.2002C19.95 21.1664 19.1664 21.95 18.2002 21.9502H5.7998C4.83344 21.9502 4.05001 21.1665 4.0498 20.2002V3.7998C4.0498 2.83331 4.83331 2.0498 5.7998 2.0498H14.1592ZM5.7998 3.5498C5.66173 3.5498 5.5498 3.66173 5.5498 3.7998V20.2002C5.55001 20.3381 5.66186 20.4502 5.7998 20.4502H18.2002C18.338 20.45 18.45 20.338 18.4502 20.2002V8.25H14.75C14.1978 8.25 13.7501 7.8022 13.75 7.25V3.5498H5.7998ZM15.25 6.75H17.4814L15.25 4.53125V6.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_print = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.5 18C15.9142 18 16.25 18.3358 16.25 18.75C16.25 19.1642 15.9142 19.5 15.5 19.5H8.5C8.08579 19.5 7.75 19.1642 7.75 18.75C7.75 18.3358 8.08579 18 8.5 18H15.5Z"
        fill="currentColor"
      />
      <path
        d="M15.5 15.75C15.9142 15.75 16.25 16.0858 16.25 16.5C16.25 16.9142 15.9142 17.25 15.5 17.25H8.5C8.08579 17.25 7.75 16.9142 7.75 16.5C7.75 16.0858 8.08579 15.75 8.5 15.75H15.5Z"
        fill="currentColor"
      />
      <path
        d="M7 9.25C7.41421 9.25 7.75 9.58579 7.75 10C7.75 10.4142 7.41421 10.75 7 10.75H5C4.58579 10.75 4.25 10.4142 4.25 10C4.25 9.58579 4.58579 9.25 5 9.25H7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 2C17.9665 2 18.75 2.7835 18.75 3.75V6.75H20.25C21.2165 6.75 22 7.5335 22 8.5V16C22 16.9665 21.2165 17.75 20.25 17.75H18.75V20.25C18.75 21.2165 17.9665 22 17 22H7C6.0335 22 5.25 21.2165 5.25 20.25V17.75H3.75C2.7835 17.75 2 16.9665 2 16V8.5C2 7.5335 2.7835 6.75 3.75 6.75H5.25V3.75C5.25 2.7835 6.0335 2 7 2H17ZM6.75 20.25C6.75 20.3881 6.86193 20.5 7 20.5H17C17.1381 20.5 17.25 20.3881 17.25 20.25V14.5H6.75V20.25ZM3.75 8.25C3.61193 8.25 3.5 8.36193 3.5 8.5V16C3.5 16.1381 3.61193 16.25 3.75 16.25H5.25V14.5H4.5C4.08579 14.5 3.75 14.1642 3.75 13.75C3.75 13.3358 4.08579 13 4.5 13H19.5C19.9142 13 20.25 13.3358 20.25 13.75C20.25 14.1642 19.9142 14.5 19.5 14.5H18.75V16.25H20.25C20.3881 16.25 20.5 16.1381 20.5 16V8.5C20.5 8.36193 20.3881 8.25 20.25 8.25H3.75ZM7 3.5C6.86193 3.5 6.75 3.61193 6.75 3.75V6.75H17.25V3.75C17.25 3.61193 17.1381 3.5 17 3.5H7Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_remove = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.35254 10.7646C8.75858 10.6834 9.15395 10.9466 9.23535 11.3525L10.2354 16.3525C10.3166 16.7586 10.0534 17.1539 9.64746 17.2354C9.24142 17.3166 8.84605 17.0534 8.76465 16.6475L7.76465 11.6475C7.68344 11.2414 7.94658 10.8461 8.35254 10.7646Z"
        fill="currentColor"
      />
      <path
        d="M12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V11.5C11.25 11.0858 11.5858 10.75 12 10.75Z"
        fill="currentColor"
      />
      <path
        d="M14.7646 11.3525C14.8461 10.9466 15.2414 10.6834 15.6475 10.7646C16.0534 10.8461 16.3166 11.2414 16.2354 11.6475L15.2354 16.6475C15.1539 17.0534 14.7586 17.3166 14.3525 17.2354C13.9466 17.1539 13.6834 16.7586 13.7646 16.3525L14.7646 11.3525Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 2.0498C13.9664 2.0498 14.7499 2.8334 14.75 3.7998V4.25H20C20.4142 4.25 20.75 4.58579 20.75 5V8C20.75 8.41421 20.4142 8.75 20 8.75H19.6445L17.999 19.6123C17.7952 20.9565 16.6398 21.9502 15.2803 21.9502H8.71973C7.36018 21.9502 6.20481 20.9565 6.00098 19.6123L4.35547 8.75H4C3.58579 8.75 3.25 8.41421 3.25 8V5C3.25 4.58579 3.58579 4.25 4 4.25H8.75V3.7998C8.75011 2.8334 9.53357 2.0498 10.5 2.0498H13ZM7.48438 19.3877C7.57717 19.9985 8.10188 20.4502 8.71973 20.4502H15.2803C15.8981 20.4502 16.4228 19.9985 16.5156 19.3877L18.1279 8.75H5.87207L7.48438 19.3877ZM4.75 7.25H19.25V5.75H4.75V7.25ZM10.5 3.5498C10.362 3.5498 10.2501 3.66182 10.25 3.7998V4.25H13.25V3.7998C13.2499 3.66182 13.138 3.5498 13 3.5498H10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_reset = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.93091 2.10514C10.3434 2.06784 10.708 2.37233 10.7454 2.78483C10.7825 3.19722 10.4781 3.56195 10.0657 3.59928C8.83502 3.71078 7.60958 4.09642 6.47876 4.77995C2.50149 7.18422 1.226 12.3573 3.63013 16.3346C6.03441 20.312 11.2074 21.5865 15.1848 19.1823C18.9718 16.893 20.3071 12.0951 18.3508 8.20768L17.1995 10.3971C17.0067 10.7636 16.5533 10.9052 16.1868 10.7126C15.8202 10.5197 15.6795 10.0655 15.8723 9.69889L17.6672 6.28776C17.807 6.02295 18.088 5.87027 18.3792 5.88932L18.5042 5.90788L22.509 6.86296C22.9116 6.95923 23.1606 7.36456 23.0647 7.76725C22.9685 8.16981 22.564 8.41773 22.1614 8.32194L19.804 7.75846C21.947 12.2975 20.3505 17.8131 15.9612 20.4665C11.2748 23.2993 5.17978 21.7964 2.34693 17.11C-0.485604 12.4238 1.01627 6.32858 5.7024 3.49577C7.03242 2.69182 8.47831 2.23667 9.93091 2.10514Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_robot = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13 15.75C13.4142 15.75 13.75 16.0858 13.75 16.5C13.75 16.9142 13.4142 17.25 13 17.25H11C10.5858 17.25 10.25 16.9142 10.25 16.5C10.25 16.0858 10.5858 15.75 11 15.75H13Z"
        fill="currentColor"
      />
      <path
        d="M9.5 12.5C10.0523 12.5 10.5 12.9477 10.5 13.5C10.5 14.0523 10.0523 14.5 9.5 14.5C8.94772 14.5 8.5 14.0523 8.5 13.5C8.5 12.9477 8.94772 12.5 9.5 12.5Z"
        fill="currentColor"
      />
      <path
        d="M14.5 12.5C15.0523 12.5 15.5 12.9477 15.5 13.5C15.5 14.0523 15.0523 14.5 14.5 14.5C13.9477 14.5 13.5 14.0523 13.5 13.5C13.5 12.9477 13.9477 12.5 14.5 12.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.75C12.9665 2.75 13.75 3.5335 13.75 4.5C13.75 5.19772 13.3407 5.79804 12.75 6.0791V7.75H18C18.9665 7.75 19.75 8.5335 19.75 9.5V10.1621C20.2902 10.2125 20.9697 10.4289 21.5527 10.9326C22.2571 11.5413 22.75 12.5087 22.75 13.9004C22.7499 15.292 22.2571 16.2596 21.5527 16.8682C20.9698 17.3717 20.2901 17.5863 19.75 17.6367V19.5C19.75 20.4665 18.9665 21.25 18 21.25H6C5.0335 21.25 4.25 20.4665 4.25 19.5V17.6367C3.70992 17.5863 3.03022 17.3717 2.44727 16.8682C1.74287 16.2596 1.2501 15.292 1.25 13.9004C1.25 12.5087 1.74291 11.5413 2.44727 10.9326C3.0303 10.4289 3.70984 10.2125 4.25 10.1621V9.5C4.25 8.5335 5.0335 7.75 6 7.75H11.25V6.0791C10.6593 5.79804 10.25 5.19772 10.25 4.5C10.25 3.5335 11.0335 2.75 12 2.75ZM6 9.25C5.86193 9.25 5.75 9.36193 5.75 9.5V19.5C5.75 19.6381 5.86193 19.75 6 19.75H18C18.1381 19.75 18.25 19.6381 18.25 19.5V9.5C18.25 9.36193 18.1381 9.25 18 9.25H6ZM4.25 11.6748C4.00027 11.7214 3.69323 11.839 3.42773 12.0684C3.09069 12.3598 2.75 12.8927 2.75 13.9004C2.7501 14.908 3.09067 15.4411 3.42773 15.7324C3.69311 15.9616 4.00037 16.0774 4.25 16.124V11.6748ZM19.75 16.124C19.9996 16.0774 20.3069 15.9616 20.5723 15.7324C20.9093 15.4411 21.2499 14.908 21.25 13.9004C21.25 12.8927 20.9093 12.3598 20.5723 12.0684C20.3068 11.839 19.9997 11.7214 19.75 11.6748V16.124ZM12 4.25C11.8619 4.25 11.75 4.36193 11.75 4.5C11.75 4.63807 11.8619 4.75 12 4.75C12.1381 4.75 12.25 4.63807 12.25 4.5C12.25 4.36193 12.1381 4.25 12 4.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_row = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.25 2C4.66421 2 5 2.33579 5 2.75V21.25C5 21.6642 4.66421 22 4.25 22H2.75C2.33579 22 2 21.6642 2 21.25V2.75C2 2.33579 2.33579 2 2.75 2H4.25Z"
        fill="currentColor"
      />
      <path
        d="M12.75 2C13.1642 2 13.5 2.33579 13.5 2.75V21.25C13.5 21.6642 13.1642 22 12.75 22H11.25C10.8358 22 10.5 21.6642 10.5 21.25V2.75C10.5 2.33579 10.8358 2 11.25 2H12.75Z"
        fill="currentColor"
      />
      <path
        d="M21.25 2C21.6642 2 22 2.33579 22 2.75V21.25C22 21.6642 21.6642 22 21.25 22H19.75C19.3358 22 19 21.6642 19 21.25V2.75C19 2.33579 19.3358 2 19.75 2H21.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_save = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1709 2.0498C16.9001 2.0498 17.6005 2.3399 18.1162 2.85547L21.1445 5.88379C21.6601 6.39941 21.9501 7.09898 21.9502 7.82812V19.2002C21.95 20.7187 20.7187 21.95 19.2002 21.9502H4.7998C3.28127 21.9501 2.05001 20.7187 2.0498 19.2002V4.7998C2.04994 3.28122 3.28121 2.04994 4.7998 2.0498H16.1709ZM4.7998 3.5498C4.10964 3.54994 3.54994 4.10964 3.5498 4.7998V19.2002C3.55001 19.8903 4.10969 20.4501 4.7998 20.4502H19.2002C19.8902 20.45 20.45 19.8902 20.4502 19.2002V7.82812C20.4501 7.4968 20.3182 7.17866 20.084 6.94434L17.0557 3.91602C16.965 3.82535 16.8618 3.74966 16.75 3.69141V6.5C16.75 7.4665 15.9665 8.25 15 8.25H8C7.0335 8.25 6.25 7.4665 6.25 6.5V3.5498H4.7998ZM17 10.25C17.9665 10.25 18.75 11.0335 18.75 12V18C18.75 18.9665 17.9665 19.75 17 19.75H7C6.0335 19.75 5.25 18.9665 5.25 18V12C5.25 11.0335 6.0335 10.25 7 10.25H17ZM7 11.75C6.86193 11.75 6.75 11.8619 6.75 12V18C6.75 18.1381 6.86193 18.25 7 18.25H17C17.1381 18.25 17.25 18.1381 17.25 18V12C17.25 11.8619 17.1381 11.75 17 11.75H7ZM7.75 6.5C7.75 6.63807 7.86193 6.75 8 6.75H15C15.1381 6.75 15.25 6.63807 15.25 6.5V3.5498H14.5V6H12.5V3.5498H7.75V6.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_search = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1401 2.05029C15.6963 2.05049 19.3901 5.74407 19.3901 10.3003V11.1401C19.3901 13.1481 18.6716 14.9878 17.479 16.4185L21.73 20.6694C22.0229 20.9623 22.0229 21.4371 21.73 21.73C21.4371 22.0229 20.9623 22.0229 20.6694 21.73L16.4185 17.479C14.9878 18.6716 13.1481 19.3901 11.1401 19.3901H10.3003C5.74407 19.3901 2.05049 15.6963 2.05029 11.1401V10.3003C2.05029 5.74395 5.74395 2.05029 10.3003 2.05029H11.1401ZM10.3003 3.55029C6.57237 3.55029 3.55029 6.57237 3.55029 10.3003V11.1401C3.55049 14.8679 6.57249 17.8901 10.3003 17.8901H11.1401C14.8678 17.8899 17.8899 14.8678 17.8901 11.1401V10.3003C17.8901 6.57249 14.8679 3.55049 11.1401 3.55029H10.3003Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_send = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M19.8551 3.15204C20.1245 3.06242 20.4219 3.13291 20.6226 3.33368C20.8233 3.53455 20.8931 3.83186 20.8033 4.10126L15.3209 20.5485C14.8017 22.1061 12.6164 22.1561 12.0269 20.6237L9.61191 14.3434L3.33261 11.9284C1.80035 11.3391 1.84967 9.15489 3.40683 8.63544L19.8551 3.15204ZM11.067 13.9479L13.4273 20.0847C13.5115 20.3036 13.8239 20.2964 13.898 20.0739L18.3756 6.64032L11.067 13.9479ZM3.88144 10.0583C3.65915 10.1325 3.65209 10.4437 3.8707 10.528L10.0064 12.8874L17.3141 5.58075L3.88144 10.0583Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_setting = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13.1858 1C13.5092 1 13.7985 1.2013 13.9074 1.5027L14.6839 3.65537C14.9622 3.72467 15.2009 3.79397 15.4033 3.86657C15.6244 3.94577 15.9093 4.06567 16.2613 4.22956L18.0696 3.27257C18.2172 3.19437 18.3862 3.16614 18.5512 3.19213C18.7162 3.21811 18.8683 3.2969 18.9848 3.41667L20.5753 5.06115C20.7865 5.28005 20.8459 5.60015 20.7271 5.87954L19.8791 7.86722C20.0198 8.12572 20.132 8.34681 20.2178 8.53161C20.3102 8.73291 20.4246 9.01011 20.561 9.3676L22.5377 10.2146C22.8346 10.3411 23.0183 10.6381 22.9985 10.956L22.8533 13.2385C22.8434 13.3867 22.7902 13.5288 22.7002 13.6471C22.6103 13.7654 22.4876 13.8547 22.3474 13.9039L20.4752 14.5694C20.4213 14.8279 20.3652 15.049 20.3058 15.236C20.21 15.5248 20.1006 15.8089 19.978 16.0874L20.9185 18.1664C20.9849 18.3125 21.0028 18.476 20.9695 18.6329C20.9363 18.7899 20.8536 18.9321 20.7337 19.0387L18.9452 20.6359C18.8274 20.7406 18.6804 20.8069 18.5239 20.8257C18.3674 20.8446 18.2089 20.8152 18.0696 20.7415L16.2261 19.7647C15.9377 19.9174 15.6401 20.0522 15.3351 20.1684L14.5299 20.4698L13.815 22.4497C13.762 22.5947 13.6664 22.7203 13.5408 22.81C13.4151 22.8998 13.2653 22.9494 13.111 22.9524L11.0211 22.9997C10.8626 23.0039 10.7068 22.9588 10.575 22.8708C10.4432 22.7827 10.342 22.656 10.2852 22.508L9.44261 20.2784C9.15513 20.1801 8.8705 20.0737 8.58904 19.9594C8.35884 19.8597 8.13211 19.7522 7.90927 19.6371L5.81934 20.5303C5.68163 20.589 5.52981 20.6065 5.38237 20.5805C5.23492 20.5545 5.09821 20.4862 4.98887 20.384L3.44232 18.9331C3.32718 18.8255 3.24876 18.6845 3.21817 18.5299C3.18757 18.3754 3.20634 18.2151 3.27183 18.0718L4.17049 16.1138C4.05098 15.8819 3.94017 15.6456 3.83831 15.4054C3.7194 15.1114 3.60936 14.8139 3.50832 14.5133L1.53939 13.9138C1.37934 13.8655 1.23975 13.7656 1.14229 13.6298C1.04483 13.4939 0.99495 13.3297 1.0004 13.1626L1.0774 11.0495C1.08288 10.9116 1.12595 10.7779 1.20195 10.6627C1.27795 10.5475 1.38398 10.4553 1.50859 10.3961L3.57431 9.4039C3.67001 9.053 3.75361 8.78021 3.82731 8.58111C3.93108 8.31518 4.04632 8.05387 4.17269 7.79792L3.27733 5.90594C3.20938 5.76227 3.18874 5.60074 3.21839 5.44459C3.24804 5.28845 3.32644 5.14573 3.44232 5.03695L4.98667 3.57837C5.09493 3.47626 5.23038 3.40761 5.37674 3.38068C5.5231 3.35375 5.67412 3.36969 5.81164 3.42657L7.89937 4.28896C8.13036 4.13496 8.33935 4.01067 8.52854 3.91057C8.75404 3.79067 9.05543 3.66527 9.43491 3.52997L10.1609 1.5049C10.2146 1.35669 10.3127 1.22867 10.4418 1.1383C10.571 1.04794 10.7248 0.999641 10.8825 1H13.1858ZM12.0264 8.72081C10.1928 8.72081 8.70674 10.1893 8.70674 12.0021C8.70674 13.8148 10.1928 15.2844 12.0264 15.2844C13.859 15.2844 15.345 13.8148 15.345 12.0021C15.345 10.1893 13.8601 8.72081 12.0264 8.72081Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_settingOutline = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9996 8C14.2087 8 15.9996 9.79086 15.9996 12C15.9996 14.2091 14.2087 16 11.9996 16C9.79065 15.9998 7.9996 14.209 7.9996 12C7.9996 9.791 9.79065 8.00022 11.9996 8ZM11.9996 9.5C10.6191 9.50022 9.4996 10.6194 9.4996 12C9.4996 13.3806 10.6191 14.4998 11.9996 14.5C13.3803 14.5 14.4996 13.3807 14.4996 12C14.4996 10.6193 13.3803 9.5 11.9996 9.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1851 1C13.5085 1 13.7979 1.20161 13.9068 1.50293L14.6832 3.65527C14.9613 3.72452 15.2006 3.79367 15.4029 3.86621C15.5134 3.90579 15.64 3.95628 15.7828 4.0166L16.2613 4.22949L18.0689 3.27246C18.2163 3.19438 18.3856 3.16661 18.5504 3.19238C18.7153 3.21835 18.8676 3.29735 18.984 3.41699L20.5748 5.06152C20.7859 5.28042 20.8459 5.60054 20.7271 5.87988L19.8785 7.86719C20.0192 8.12546 20.1316 8.34655 20.2174 8.53125C20.3097 8.73243 20.4239 9.01001 20.5601 9.36719L22.5377 10.2148L22.6432 10.2695C22.8771 10.4155 23.016 10.6779 22.9986 10.9561L22.8531 13.2383L22.8375 13.3486C22.8141 13.4565 22.7672 13.5589 22.6998 13.6475L22.6266 13.7305C22.5476 13.8076 22.4523 13.8674 22.3473 13.9043L20.4752 14.5693C20.4213 14.8278 20.3647 15.0493 20.3053 15.2363L20.1519 15.666C20.0973 15.8078 20.0394 15.9488 19.9781 16.0879L20.9185 18.166L20.9586 18.2793C20.9899 18.3941 20.9942 18.5153 20.9693 18.6328L20.9351 18.7471C20.8923 18.8584 20.823 18.959 20.733 19.0391L18.9449 20.6357L18.8512 20.707C18.753 20.7705 18.6411 20.812 18.524 20.8262L18.4059 20.8311C18.2889 20.8272 18.1732 20.7964 18.0689 20.7412L16.2262 19.7647C15.9378 19.9173 15.6394 20.0519 15.3346 20.168L14.5299 20.4697L13.815 22.4502L13.7672 22.5547C13.7121 22.6552 13.6346 22.7424 13.5406 22.8096L13.442 22.8701C13.3398 22.9219 13.2264 22.9498 13.1109 22.9522L11.0211 23C10.9023 23.0031 10.7841 22.9783 10.6773 22.9287L10.5748 22.8711C10.4431 22.7831 10.3415 22.6557 10.2848 22.5078L9.44198 20.2783C9.1547 20.1801 8.86973 20.0733 8.58847 19.959C8.35848 19.8594 8.13142 19.7518 7.90878 19.6367L5.81894 20.5303L5.71347 20.5664C5.64162 20.5854 5.56705 20.594 5.49276 20.5918L5.38241 20.5801C5.27208 20.5606 5.1671 20.5175 5.07577 20.4541L4.98886 20.3838L3.44198 18.9326C3.35574 18.8519 3.28988 18.7525 3.2496 18.6426L3.21737 18.5303C3.18685 18.376 3.20586 18.2154 3.27109 18.0723L4.1705 16.1143C4.05101 15.8824 3.93933 15.6454 3.83749 15.4053C3.71871 15.1116 3.60934 14.814 3.50839 14.5137L1.53866 13.9141C1.41879 13.8777 1.31002 13.8122 1.22226 13.7246L1.14218 13.6299C1.04481 13.4941 0.994151 13.3291 0.999601 13.1621L1.07675 11.0498C1.08222 10.9121 1.1259 10.7782 1.20175 10.6631C1.25874 10.5767 1.33262 10.5026 1.41855 10.4463L1.50839 10.3965L3.57382 9.4043C3.6695 9.05348 3.75306 8.78014 3.82675 8.58106C3.9305 8.31518 4.0461 8.05376 4.17245 7.79785L3.27694 5.90625C3.20906 5.76263 3.18873 5.6004 3.21835 5.44434C3.24057 5.3276 3.2899 5.21813 3.36191 5.125L3.44198 5.03711L4.98593 3.57813C5.09409 3.47611 5.23034 3.40784 5.37655 3.38086C5.52273 3.354 5.67376 3.37002 5.81112 3.42676L7.89901 4.28906C8.12988 4.13515 8.33881 4.01023 8.52792 3.91016C8.75326 3.79034 9.05504 3.66547 9.43417 3.53027L10.1607 1.50488C10.2143 1.35699 10.3122 1.22899 10.441 1.13867C10.57 1.04839 10.7249 0.999723 10.8824 1H13.1851ZM10.8463 4.03613C10.6946 4.45908 10.3613 4.79149 9.93808 4.94238C9.5875 5.06739 9.36381 5.16528 9.23202 5.23535L9.23007 5.23633C9.09075 5.31005 8.9247 5.40801 8.73105 5.53711C8.31531 5.81413 7.78855 5.86633 7.32675 5.67578L5.67343 4.99219L4.86484 5.75586L5.52792 7.15625C5.72387 7.57031 5.71997 8.05117 5.51718 8.46192C5.41394 8.67102 5.31944 8.88459 5.23398 9.10156L5.14218 9.37598C5.10686 9.491 5.06681 9.63118 5.02109 9.79883C4.90655 10.2184 4.6153 10.5675 4.22323 10.7559L2.55917 11.5547L2.51913 12.6436L3.94491 13.0781L4.11386 13.1416C4.49659 13.3106 4.79411 13.6335 4.92929 14.0352C5.01804 14.2992 5.11534 14.5609 5.21933 14.8193L5.35507 15.126C5.40249 15.2271 5.45233 15.3275 5.50351 15.4268C5.71457 15.8364 5.72588 16.3204 5.53378 16.7393L4.85898 18.2061L5.66659 18.9639L7.31894 18.2578L7.47616 18.2012C7.84698 18.0894 8.24932 18.125 8.59726 18.3047C8.78187 18.4001 8.97024 18.4892 9.16073 18.5723C9.28594 18.6231 9.41211 18.6724 9.53866 18.7197L9.92733 18.8594L10.0816 18.9219C10.4317 19.0869 10.7069 19.382 10.8453 19.748L11.5025 21.4883L12.5748 21.4639L13.1187 19.96L13.1832 19.8096C13.3508 19.4678 13.6433 19.2005 14.0035 19.0654L14.8004 18.7666L15.1676 18.6143C15.288 18.5597 15.4071 18.5013 15.524 18.4395L15.692 18.3623C16.0928 18.2097 16.5441 18.236 16.9283 18.4395L18.3238 19.1787L19.3248 18.2842L18.6109 16.7061C18.4355 16.318 18.4336 15.8732 18.6051 15.4834C18.7075 15.2508 18.7973 15.0126 18.8775 14.7715C18.9163 14.6479 18.9608 14.4825 19.0064 14.2637L19.0582 14.0762C19.2064 13.6503 19.5409 13.3098 19.9723 13.1563L21.3873 12.6523L21.4674 11.3877L19.9703 10.7461C19.5971 10.5861 19.3035 10.2817 19.1588 9.90234C19.0283 9.56034 18.9273 9.31663 18.8541 9.15723C18.7854 9.00988 18.689 8.81973 18.5611 8.58496C18.3418 8.18212 18.3187 7.70024 18.4986 7.27832L19.1519 5.74707L18.2867 4.85352L16.9625 5.55567C16.5475 5.77509 16.0531 5.78799 15.6275 5.58984C15.2974 5.43614 15.0582 5.33606 14.8971 5.27832C14.7581 5.22851 14.5701 5.17338 14.3209 5.11133C13.8356 4.99032 13.4418 4.63455 13.2721 4.16406L12.6715 2.5H11.3971L10.8463 4.03613Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_shield = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M16.2549 9.3486C16.5477 9.05582 17.0225 9.05602 17.3154 9.3486C17.6083 9.64149 17.6083 10.1163 17.3154 10.4091L12.0859 15.6386C11.6954 16.0291 11.0624 16.0291 10.6719 15.6386L7.46973 12.4365C7.17728 12.1436 7.17703 11.6687 7.46973 11.3759C7.76264 11.0833 8.23844 11.0831 8.53125 11.3759L11.3789 14.2246L16.2549 9.3486Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.501 1.4404C11.8718 1.27889 12.3024 1.30624 12.6533 1.52145L20.1533 6.12204C20.5238 6.34931 20.7499 6.75284 20.75 7.18747V10.5302C20.75 11.8881 20.6005 13.3051 20.0645 14.6425C19.5554 15.9124 18.7155 17.6378 17.4502 19.1894C16.1835 20.7426 14.4592 22.1581 12.1816 22.7275L12 22.7734L11.8184 22.7275C9.54076 22.1581 7.81646 20.7426 6.5498 19.1894C5.2845 17.6378 4.4446 15.9124 3.93555 14.6425C3.39949 13.3051 3.25 11.8881 3.25 10.5302V7.18747C3.25007 6.75284 3.47619 6.34931 3.84668 6.12204L11.3467 1.52145L11.501 1.4404ZM4.75 7.32712V10.5302C4.75 11.7887 4.89082 12.9929 5.32812 14.084C5.80497 15.2735 6.57635 16.8486 7.71191 18.2412C8.80911 19.5866 10.2182 20.7255 12 21.2216C13.7818 20.7255 15.1909 19.5866 16.2881 18.2412C17.4236 16.8486 18.195 15.2735 18.6719 14.084C19.1092 12.9929 19.25 11.7887 19.25 10.5302V7.32712L12 2.87985L4.75 7.32712Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_sidebar = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 3C20.6569 3 22 4.34315 22 6V18L21.9961 18.1543C21.9184 19.6883 20.6883 20.9184 19.1543 20.9961L19 21H5L4.8457 20.9961C3.31166 20.9184 2.08163 19.6883 2.00391 18.1543L2 18V6C2 4.34315 3.34315 3 5 3H19ZM5 4.5C4.17157 4.5 3.5 5.17157 3.5 6V18C3.5 18.8284 4.17157 19.5 5 19.5H8V4.5H5ZM9.5 19.5H19C19.8284 19.5 20.5 18.8284 20.5 18V6C20.5 5.17157 19.8284 4.5 19 4.5H9.5V19.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_store = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3817 6C19.0445 6 19.6507 6.37497 19.9472 6.96777L21.9472 10.9678C22.5286 12.1313 21.6825 13.5 20.3817 13.5H19.7499V19.75C19.7499 20.1642 19.4141 20.5 18.9999 20.5C18.5858 20.4998 18.2499 20.1641 18.2499 19.75V13.5H13.7499V18.75C13.7499 19.7165 12.9664 20.5 11.9999 20.5H5.99991C5.03355 20.4998 4.24991 19.7164 4.24991 18.75V13.5H3.61807C2.3175 13.4998 1.47136 12.1312 2.05264 10.9678L4.05264 6.96777C4.34903 6.375 4.95534 6.00012 5.61807 6H18.3817ZM5.74991 18.75C5.74991 18.888 5.86198 18.9998 5.99991 19H11.9999C12.138 19 12.2499 18.8881 12.2499 18.75V13.5H5.74991V18.75ZM5.61807 7.5C5.5235 7.50012 5.43674 7.55407 5.39444 7.63867L3.39444 11.6387C3.31183 11.8047 3.43258 11.9998 3.61807 12H20.3817C20.5675 12 20.6882 11.8048 20.6054 11.6387L18.6054 7.63867C18.563 7.55405 18.4764 7.5 18.3817 7.5H5.61807Z"
        fill="currentColor"
      />
      <path
        d="M17.9999 4C18.4141 4 18.7499 4.33579 18.7499 4.75C18.7499 5.16421 18.4141 5.5 17.9999 5.5H5.99991C5.58584 5.49983 5.24991 5.16411 5.24991 4.75C5.24991 4.33589 5.58584 4.00017 5.99991 4H17.9999Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_synchronize = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.30769 10.8175C3.57806 10.5965 3.96606 10.5921 4.24226 10.8057L6.33991 12.4278C6.66706 12.6813 6.7261 13.1521 6.47272 13.4796C6.21918 13.8067 5.74841 13.8675 5.42097 13.6143L4.62116 12.9952C4.92795 14.8404 5.99601 17.3161 8.753 18.6602C12.4087 20.4424 15.8051 18.6615 17.0333 17.5479C17.34 17.2701 17.8136 17.2925 18.0919 17.5987C18.3701 17.9055 18.347 18.381 18.0401 18.6592C16.5549 20.0056 12.5074 22.16 8.09479 20.0089C4.62913 18.3191 3.39551 15.1712 3.09675 12.9298L2.27546 13.6016C1.95491 13.8639 1.48116 13.8165 1.21882 13.4962C0.956723 13.1758 1.00408 12.7028 1.32429 12.4405L3.30769 10.8175Z"
        fill="currentColor"
      />
      <path
        d="M5.96003 5.34089C7.44498 3.99457 11.4916 1.83985 15.9044 3.99128C19.3702 5.68114 20.6036 8.82876 20.9024 11.0704L21.7247 10.3985C22.0452 10.1363 22.518 10.1837 22.7803 10.504C23.0426 10.8245 22.9953 11.2973 22.6749 11.5596L20.6915 13.1827C20.4211 13.4035 20.034 13.408 19.7579 13.1944L17.6602 11.5723C17.333 11.3189 17.2732 10.8481 17.5264 10.5206C17.78 10.1931 18.2516 10.1324 18.5792 10.3858L19.379 11.005C19.0722 9.15965 18.0042 6.68321 15.2471 5.33893C11.5915 3.55662 8.19499 5.33864 6.96687 6.45222C6.66013 6.72978 6.1864 6.70667 5.90827 6.40046C5.63009 6.09371 5.65335 5.61916 5.96003 5.34089Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_thumbsDown = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 21.25C14.7426 21.25 15.75 20.2426 15.75 19V15.5C15.75 15.3619 15.8619 15.25 16 15.25H18.8936C20.7018 15.25 22.0178 13.5347 21.5498 11.7881L20.1484 6.55762C19.5504 4.3259 17.4329 2.84845 15.1318 3.05664L8.05371 3.69727C7.76261 3.13498 7.17686 2.75 6.5 2.75H4.5C3.25736 2.75 2.25 3.75736 2.25 5V13C2.25 14.2426 3.25736 15.25 4.5 15.25H8.25V15.1689C8.57271 15.4885 8.90914 15.8467 9.23438 16.2344C10.0174 17.1678 10.7037 18.2229 11.0371 19.2568C11.3509 20.2303 12.2316 21.25 13.5 21.25ZM13.5 19.75C13.1116 19.75 12.6594 19.4004 12.4648 18.7969C12.0481 17.5041 11.2278 16.2778 10.3828 15.2705C9.6516 14.3988 8.87296 13.658 8.25 13.1416V5.18555L15.2676 4.55078C16.8419 4.40844 18.2901 5.41938 18.6992 6.94629L20.1006 12.1768C20.3132 12.9706 19.7154 13.75 18.8936 13.75H16C15.0335 13.75 14.25 14.5335 14.25 15.5V19C14.25 19.4142 13.9142 19.75 13.5 19.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_thumbsUp = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 2.75C14.7426 2.75 15.75 3.75736 15.75 5V8.5C15.75 8.63807 15.8619 8.75 16 8.75H18.8936C20.7018 8.75 22.0178 10.4653 21.5498 12.2119L20.1484 17.4424C19.5504 19.6741 17.4329 21.1516 15.1318 20.9434L8.05371 20.3027C7.76261 20.865 7.17686 21.25 6.5 21.25H4.5C3.25736 21.25 2.25 20.2426 2.25 19V11C2.25 9.75736 3.25736 8.75 4.5 8.75H8.25V8.83105C8.57271 8.51149 8.90914 8.15334 9.23438 7.76562C10.0174 6.83217 10.7037 5.77712 11.0371 4.74316C11.3509 3.76975 12.2316 2.75 13.5 2.75ZM13.5 4.25C13.1116 4.25 12.6594 4.59961 12.4648 5.20312C12.0481 6.49588 11.2278 7.72217 10.3828 8.72949C9.6516 9.60115 8.87296 10.342 8.25 10.8584V18.8145L15.2676 19.4492C16.8419 19.5916 18.2901 18.5806 18.6992 17.0537L20.1006 11.8232C20.3132 11.0294 19.7154 10.25 18.8936 10.25H16C15.0335 10.25 14.25 9.4665 14.25 8.5V5C14.25 4.58579 13.9142 4.25 13.5 4.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_updown = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.00051 2.44141C6.2852 2.18705 6.71591 2.18689 7.00051 2.44141L11.5005 6.46582C11.8087 6.74194 11.8348 7.21583 11.5591 7.52441C11.283 7.83283 10.8092 7.8588 10.5005 7.58301L7.25051 4.67676V21C7.25051 21.4141 6.9145 21.7497 6.50051 21.75C6.0863 21.75 5.75051 21.4142 5.75051 21V4.67676L2.50051 7.58301C2.19192 7.85898 1.7181 7.8327 1.44192 7.52441C1.16587 7.21575 1.192 6.74198 1.50051 6.46582L6.00051 2.44141Z"
        fill="currentColor"
      />
      <path
        d="M17.5005 2.25C17.9145 2.25026 18.2505 2.58595 18.2505 3V19.3232L21.5005 16.417C21.8092 16.1412 22.283 16.1672 22.5591 16.4756C22.8348 16.7842 22.8087 17.2581 22.5005 17.5342L18.0005 21.5586C17.7159 21.8131 17.2852 21.813 17.0005 21.5586L12.5005 17.5342C12.192 17.258 12.1659 16.7843 12.4419 16.4756C12.7181 16.1673 13.1919 16.141 13.5005 16.417L16.7505 19.3232V3C16.7505 2.58579 17.0863 2.25 17.5005 2.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_user = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 12C9.78125 12 8 10.2188 8 8C8 5.8125 9.78125 4 12 4C14.1875 4 16 5.8125 16 8C16 10.2188 14.1875 12 12 12ZM10.5625 13.5H13.4062C16.5 13.5 19 16 19 19.0938C19 19.5938 18.5625 20 18.0625 20H5.90625C5.40625 20 5 19.5938 5 19.0938C5 16 7.46875 13.5 10.5625 13.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_users = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.4062 13.5C14.5 13.5 17 16 17 19.0938C17 19.5938 16.5625 20 16.0625 20H3.90625C3.40625 20 3 19.5938 3 19.0938C3 16 5.46875 13.5 8.5625 13.5H11.4062Z"
        fill="currentColor"
      />
      <path
        d="M15.4189 13.5C18.8153 13.5001 21.5 16.4402 21.5 20H20.5C20.5 16.9999 18.3097 14.6219 15.626 14.5049C15.1851 14.0929 14.6769 13.7528 14.1201 13.5H15.4189Z"
        fill="currentColor"
      />
      <path
        d="M10 4C12.1875 4 14 5.8125 14 8C14 10.2188 12.1875 12 10 12C7.78125 12 6 10.2188 6 8C6 5.8125 7.78125 4 10 4Z"
        fill="currentColor"
      />
      <path
        d="M14 4C16.1902 4 18 5.8098 18 8C18 10.2201 16.1877 12 14 12V11C15.6405 11 17 9.66273 17 8C17 6.36208 15.6379 5 14 5V4Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_visibilityOff = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.005 6.49997C14.765 6.49997 17.005 8.73997 17.005 11.5C17.005 12.0334 16.9175 12.5399 16.7589 13.0195C16.696 13.2099 16.7371 13.4221 16.8789 13.5639L19.2419 15.9269C19.4249 16.1098 19.718 16.1238 19.9101 15.9506C21.0646 14.9093 22.012 13.6433 22.6833 12.222C22.8991 11.7649 22.8987 11.2351 22.6824 10.7782C20.7868 6.77297 16.7164 3.99997 11.995 3.99997C10.8718 3.99997 9.78726 4.16089 8.76197 4.45689C8.41038 4.5584 8.31181 4.99675 8.57057 5.25552L9.94113 6.62608C10.0829 6.7679 10.2951 6.80902 10.4855 6.74607C10.9651 6.58753 11.4716 6.49997 12.005 6.49997ZM2.64003 3.13497C2.28933 3.48568 2.28933 4.05427 2.64003 4.40497L4.34436 6.10931C4.55708 6.32203 4.53453 6.6725 4.3061 6.86825C3.05274 7.94231 2.03087 9.27279 1.31825 10.777C1.10145 11.2347 1.10158 11.7654 1.31827 12.2231C3.21416 16.2276 7.28421 19 12.005 19C13.4381 19 14.8113 18.7435 16.0772 18.2781C16.265 18.2091 16.4767 18.2517 16.6182 18.3931L16.805 18.58L19.0995 20.8666C19.4507 21.2166 20.0189 21.2161 20.3695 20.8655C20.7205 20.5145 20.7205 19.9454 20.3695 19.5944L3.91003 3.13497C3.55933 2.78427 2.99073 2.78427 2.64003 3.13497ZM7.26719 9.94414C7.37767 9.6199 7.78645 9.5514 8.02867 9.79361L8.88746 10.6524C9.01024 10.7752 9.05723 10.9524 9.0326 11.1243C9.01484 11.2483 9.00503 11.3741 9.00503 11.5C9.00503 13.16 10.345 14.5 12.005 14.5C12.1309 14.5 12.2567 14.4902 12.3807 14.4724C12.5526 14.4478 12.7298 14.4948 12.8526 14.6175L13.7114 15.4763C13.9536 15.7185 13.8851 16.1273 13.5609 16.2378C13.0704 16.4049 12.5496 16.5 12.005 16.5C9.24503 16.5 7.00503 14.26 7.00503 11.5C7.00503 10.9554 7.10006 10.4346 7.26719 9.94414ZM12.015 8.50997C11.9492 8.51385 11.9188 8.59373 11.9654 8.64039L14.881 11.556C14.9274 11.6024 15.0069 11.5751 15.015 11.51C15.015 9.84997 13.675 8.50997 12.015 8.50997Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_visibilityOn = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.0001 9C13.66 9.00011 15.0001 10.3401 15.0001 12C15.0001 13.6599 13.66 14.9999 12.0001 15C10.3401 15 9.00013 13.66 9.00013 12C9.00013 11.6916 9.04599 11.3941 9.13197 11.1143C9.36671 11.6362 9.8907 12 10.5001 12C11.3285 11.9999 12.0001 11.3284 12.0001 10.5C12.0001 9.8906 11.6363 9.3666 11.1144 9.13184C11.3941 9.04589 11.6918 9 12.0001 9Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 4.5C16.7207 4.50008 20.7907 7.27215 22.6867 11.2764C22.9034 11.7341 22.9034 12.2659 22.6867 12.7236C20.7907 16.7279 16.7207 19.4999 12.0001 19.5C7.27956 19.5 3.20962 16.7278 1.31361 12.7236C1.09688 12.2659 1.09688 11.7341 1.31361 11.2764C3.20962 7.27217 7.27956 4.5 12.0001 4.5ZM12.0001 7C9.24013 7 7.00013 9.24 7.00013 12C7.00013 14.76 9.24013 17 12.0001 17C14.76 16.9999 17.0001 14.7599 17.0001 12C17.0001 9.24007 14.76 7.00011 12.0001 7Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_warehouseFill = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.5791 3.79443C11.8489 3.68392 12.1511 3.68392 12.4209 3.79443L21.3105 7.437C21.7277 7.60805 22 8.01449 22 8.46532V19.7329C21.9998 20.0396 21.751 20.2886 21.4443 20.2886H19.8887C19.5821 20.2884 19.3332 20.0395 19.333 19.7329V10.8433C19.3328 10.2299 18.836 9.73314 18.2227 9.7329H5.77734C5.16402 9.73314 4.6672 10.2299 4.66699 10.8433V19.7329C4.66679 20.0395 4.41793 20.2885 4.11133 20.2886H2.55566C2.24896 20.2886 2.0002 20.0396 2 19.7329V8.46532C2 8.01449 2.27234 7.60806 2.68945 7.437L11.5791 3.79443Z"
        fill="currentColor"
      />
      <path
        d="M17.5557 18.0659C17.8625 18.066 18.1113 18.3148 18.1113 18.6216V19.7329C18.1111 20.0395 17.8623 20.2885 17.5557 20.2886H6.44434C6.13769 20.2885 5.88886 20.0395 5.88867 19.7329V18.6216C5.88867 18.3148 6.13757 18.066 6.44434 18.0659H17.5557Z"
        fill="currentColor"
      />
      <path
        d="M17.5557 14.1772C17.8625 14.1773 18.1113 14.4261 18.1113 14.7329V16.3989C18.1113 16.7057 17.8625 16.9545 17.5557 16.9546H6.44434C6.13757 16.9545 5.88867 16.7057 5.88867 16.3989V14.7329C5.88867 14.4261 6.13757 14.1773 6.44434 14.1772H17.5557Z"
        fill="currentColor"
      />
      <path
        d="M17.5557 10.8433C17.8624 10.8433 18.1112 11.0923 18.1113 11.3989V12.5102C18.1113 12.817 17.8625 13.0659 17.5557 13.0659H6.44434C6.13757 13.0658 5.88867 12.817 5.88867 12.5102V11.3989C5.88883 11.0923 6.13767 10.8433 6.44434 10.8433H17.5557Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_warehouseOutline = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.3311 3.81877C11.7597 3.64309 12.2403 3.64309 12.6689 3.81877L20.7803 7.14298C21.4424 7.41452 21.875 8.05913 21.875 8.77482V19.5629C21.875 19.9771 21.5392 20.3129 21.125 20.3129C20.7108 20.3129 20.375 19.9771 20.375 19.5629V8.77482C20.375 8.66775 20.31 8.57129 20.2109 8.53068L12.0996 5.20646C12.0357 5.18039 11.9643 5.18039 11.9004 5.20646L3.78906 8.53068C3.69 8.57129 3.62502 8.66775 3.625 8.77482V19.5629C3.62496 19.9771 3.28919 20.3129 2.875 20.3129C2.46081 20.3129 2.12504 19.9771 2.125 19.5629V8.77482C2.12502 8.05913 2.55757 7.41452 3.21973 7.14298L11.3311 3.81877Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0693 10.1947C17.7633 10.1949 18.3259 10.7577 18.3262 11.4516V19.0561C18.3261 19.7501 17.7633 20.3128 17.0693 20.3129H6.93066C6.23659 20.3128 5.67395 19.7501 5.67383 19.0561V11.4516C5.67407 10.7576 6.23668 10.1948 6.93066 10.1947H17.0693ZM7.17383 17.2719V18.8129H16.8262V17.2719H7.17383ZM7.17383 15.7719H16.8262V14.7367H7.17383V15.7719ZM7.17383 13.2367H16.8262V11.6947H7.17383V13.2367Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_warningFill = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.2158 3.74962C11.6119 3.24586 12.387 3.24593 12.7832 3.74962L12.8623 3.86583L21.8252 19.1217C22.2167 19.7883 21.7359 20.6285 20.9629 20.6285H3.0361C2.26345 20.6281 1.78266 19.7881 2.1738 19.1217L11.1377 3.86583L11.2158 3.74962ZM12 15.8785C11.4477 15.8785 11 16.3262 11 16.8785C11.0001 17.4307 11.4478 17.8785 12 17.8785C12.5521 17.8785 12.9998 17.4307 13 16.8785C13 16.3263 12.5522 15.8785 12 15.8785ZM12 9.12853C11.5858 9.12853 11.25 9.46431 11.25 9.87853V14.3785C11.2501 14.7926 11.5859 15.1285 12 15.1285C12.4141 15.1285 12.7498 14.7926 12.75 14.3785V9.87853C12.75 9.46433 12.4142 9.12855 12 9.12853Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_warningOutline = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 15.8785C12.5522 15.8785 13 16.3263 13 16.8785C12.9998 17.4307 12.5521 17.8785 12 17.8785C11.4478 17.8785 11.0001 17.4307 11 16.8785C11 16.3262 11.4477 15.8785 12 15.8785Z"
        fill="currentColor"
      />
      <path
        d="M12 9.12853C12.4142 9.12855 12.75 9.46433 12.75 9.87853V14.3785C12.7498 14.7926 12.4141 15.1285 12 15.1285C11.5859 15.1285 11.2501 14.7926 11.25 14.3785V9.87853C11.25 9.46431 11.5858 9.12853 12 9.12853Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2158 3.74962C11.6119 3.24586 12.387 3.24593 12.7832 3.74962L12.8623 3.86583L21.8252 19.1217C22.2167 19.7883 21.7359 20.6285 20.9629 20.6285H3.0361C2.26345 20.6281 1.78265 19.7881 2.1738 19.1217L11.1377 3.86583L11.2158 3.74962ZM3.91013 19.1285H20.0888L11.999 5.359L3.91013 19.1285Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Icon_youtube = (p: IconRenderProps) => {
  const { size = 24, ...rest } = p;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20 5C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V7C2 5.89543 2.89543 5 4 5H20ZM10.5273 8.51855C10.1951 8.29704 9.75 8.53522 9.75 8.93457V15.0654C9.75 15.4648 10.1951 15.703 10.5273 15.4814L15.126 12.416C15.4228 12.2181 15.4228 11.7819 15.126 11.584L10.5273 8.51855Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ICONS = {
  add: Icon_add,
  alert: Icon_alert,
  alignKorean: Icon_alignKorean,
  archive: Icon_archive,
  arrowDown: Icon_arrowDown,
  arrowLeft: Icon_arrowLeft,
  arrowRight: Icon_arrowRight,
  arrowUp: Icon_arrowUp,
  asterisk: Icon_asterisk,
  attachFile: Icon_attachFile,
  barcode: Icon_barcode,
  bell: Icon_bell,
  bill: Icon_bill,
  board: Icon_board,
  box: Icon_box,
  camera: Icon_camera,
  cancelFill: Icon_cancelFill,
  cancelOutline: Icon_cancelOutline,
  caretDown: Icon_caretDown,
  caretLeft: Icon_caretLeft,
  caretRight: Icon_caretRight,
  caretUp: Icon_caretUp,
  check: Icon_check,
  checkFill: Icon_checkFill,
  checkOutline: Icon_checkOutline,
  checkboxCheck: Icon_checkboxCheck,
  checkboxIndeterminate: Icon_checkboxIndeterminate,
  chevronDown: Icon_chevronDown,
  chevronLeft: Icon_chevronLeft,
  chevronLeftEnd: Icon_chevronLeftEnd,
  chevronRight: Icon_chevronRight,
  chevronRightEnd: Icon_chevronRightEnd,
  chevronUp: Icon_chevronUp,
  clockFill: Icon_clockFill,
  clockOutline: Icon_clockOutline,
  close: Icon_close,
  copy: Icon_copy,
  coupon: Icon_coupon,
  dashboard: Icon_dashboard,
  date: Icon_date,
  delete: Icon_delete,
  dot: Icon_dot,
  download: Icon_download,
  drag: Icon_drag,
  edit: Icon_edit,
  etc: Icon_etc,
  event: Icon_event,
  global: Icon_global,
  helpFill: Icon_helpFill,
  helpOutline: Icon_helpOutline,
  history: Icon_history,
  image: Icon_image,
  inline: Icon_inline,
  launcher: Icon_launcher,
  leftRight: Icon_leftRight,
  line: Icon_line,
  location: Icon_location,
  logout: Icon_logout,
  minus: Icon_minus,
  monitor: Icon_monitor,
  new: Icon_new,
  notificationFill: Icon_notificationFill,
  notificationOutline: Icon_notificationOutline,
  notion: Icon_notion,
  outline: Icon_outline,
  pageEdit: Icon_pageEdit,
  pageMove: Icon_pageMove,
  pdf: Icon_pdf,
  print: Icon_print,
  remove: Icon_remove,
  reset: Icon_reset,
  robot: Icon_robot,
  row: Icon_row,
  save: Icon_save,
  search: Icon_search,
  send: Icon_send,
  setting: Icon_setting,
  settingOutline: Icon_settingOutline,
  shield: Icon_shield,
  sidebar: Icon_sidebar,
  store: Icon_store,
  synchronize: Icon_synchronize,
  thumbsDown: Icon_thumbsDown,
  thumbsUp: Icon_thumbsUp,
  updown: Icon_updown,
  user: Icon_user,
  users: Icon_users,
  visibilityOff: Icon_visibilityOff,
  visibilityOn: Icon_visibilityOn,
  warehouseFill: Icon_warehouseFill,
  warehouseOutline: Icon_warehouseOutline,
  warningFill: Icon_warningFill,
  warningOutline: Icon_warningOutline,
  youtube: Icon_youtube,
} as const;

export type SIconName = keyof typeof ICONS;
